import React, { Fragment } from 'react';

export const bgFlag = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 79 97"
    width={79}
    className="pos-a"
    style={{ filter: 'drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.1))' }}
    aria-hidden
  >
    <path d="M0 4c0-2.2 1.8-4 4-4h71c2.2 0 4 1.8 4 4v93L39.5 71.3 0 97V4z" style={{ fill: '#2070e8' }} />
  </svg>
);

export const iconConvertibleSymbol = (
  <Fragment key="iconConvertibleSymbol">
    <defs>
      <radialGradient
        id="radial-gradient-conv"
        cx={-20.676}
        cy={419.151}
        r={1}
        gradientTransform="matrix(.01424 1.542 29.1169 -.2689 -12168.57 169.565)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#091a33' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </radialGradient>
      <linearGradient
        id="radial-gradient-conv-2"
        x1={60.787}
        x2={63.633}
        y1={10.447}
        y2={8.13}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#091a33' }} />
        <stop offset={1} style={{ stopColor: '#2070e8' }} />
      </linearGradient>
      <linearGradient
        id="radial-gradient-conv-3"
        x1={16.34}
        x2={16.598}
        y1={3.986}
        y2={12.258}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#84c8ff', stopOpacity: 0 }} />
        <stop offset={1} style={{ stopColor: '#219afe' }} />
      </linearGradient>
      <linearGradient
        id="radial-gradient-conv-4"
        x1={52.34}
        x2={52.598}
        y1={4.404}
        y2={12.677}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#84c8ff', stopOpacity: 0 }} />
        <stop offset={1} style={{ stopColor: '#219afe' }} />
      </linearGradient>
    </defs>
    <symbol id="icon-convertible" viewBox="0 0 71 27">
      <style dangerouslySetInnerHTML={{ __html: '.icon-convert-st9{fill:#033e96}' }} />
      <path
        d="M35.5 23.4c16.1-.1 29.1.4 29.1 1.3s-13 1.7-29.1 1.8c-16.1.1-29.1-.4-29.1-1.3 0-.8 13-1.6 29.1-1.8z"
        style={{ fill: 'url(#radial-gradient-conv)' }}
      />
      <path
        d="M16.2 14c-5.9.6-9.2 2.4-9.2 2.4s-1.1.5-.9 2c.2 1.8.9 2.6.9 2.6l-.5.3.1 1.4-.3.3 4.8.9c3.1 0 9.2-.1 9.2-.2s17.8 0 26.8 0l10.8-.7c3.8-.5 5.8-3.1 6.2-4 .3-.9.4-1.6.2-2.9-.1-.7-.8-1.9-1.8-2.4-1.5-.8-7.7-1.8-7.7-1.8s-1.3.9-8 1.2c-5.4.2-11.6.5-17.8.5-6.6 0-8.7 0-12.8.4z"
        style={{ fill: '#fff', stroke: '#007ee5', strokeWidth: '.1' }}
      />
      <path
        d="M35.3 9.5c-3.4 1.4-6.5 4.1-6.5 4.1l10.8-.1c5.9-.9 13-.5 15-1.5-2.3-.4-3.7-.7-6.9-.5v1.3c-5.6.2-12.9.5-12.7.4 1.5-1.3 3.3-2.4 3.5-2.5.2-.1.1-.4 0-.7 0-.2-1.2-.9-1.7-.9-.1-.1-.7.1-1.5.4zM7.7 17.4c-.8 1.1-.8 3.5-.8 3.5-.5-.9-.7-1.6-.9-2.9.1-.7.3-1.1.9-1.6 0 0 2.4-1.4 7.9-2.2 5.5-.8 10.2-.9 16.8-.6-5.4.3-9.9.4-13.8.8-5.4.4-9.3 1.9-10.1 3zm3.2 2.6c-1.1 1-3.7.9-3.7.9l-.6.4.1 1.4-.2.3 4.7.9 9-.2h26.7l10.8-.7c1.3-.1 1.7-.3 2.9-.8 1.5-.7 2-1.4 3.2-2.6.5-1.1.7-2.2.5-3.5-.3-1-.6-1.6-1.9-2.5-2.8-.8-4.6-1.2-7.6-1.7l-2.2.6c1.1.2 2.5.7 3.6 1 .9.3 1.4 1.1 1.4 1.9-.2 1.8-9.5 2.3-9.5 2.3s-1.1.6-1.6.2c-.5-.4.6-1.3 0-1.7-.6-.4-20.1-1.2-21.8 0-1.4 1-2.2 1.3-3.8 2-3.7 1.6-7-.7-10 1.8z"
        style={{ fill: '#cce0ff' }}
      />
      <path
        d="M27 20.2c5.8-.5 10.5-.9 15.3-1.1.9 0 1.8.2 2.6.6.2.1.1.4-.1.4-1.6.2-5.8.7-9.7 1-4.9.3-12.3.5-12.3.5l1.1-.5c.8-.5 1.9-.8 3.1-.9z"
        style={{ fill: '#fff' }}
      />
      <path
        d="M60.9 17.9c-.4 1-.5 1.8-.7 3 0 0 1.2-.1 1.8-.4.6-.3 1-.4 1.4-1 .4-.6.7-2 .6-3.2l-2.2.7c-.4.1-.7.5-.9.9z"
        style={{
          fill: 'url(#radial-gradient-conv-2)',
        }}
      />
      <path
        d="M10.6 23.6c-.8-5.7 2.7-8 5.8-7.9 3.1.1 6 2.1 5.8 8 0 .3-1.2-.6-5.8.2-6-.7-5.7.2-5.8-.3z"
        style={{
          fill: 'url(#radial-gradient-conv-3)',
        }}
      />
      <path
        d="M46.6 23.8c-.8-5.7 2.7-8.6 5.8-8.5 3.1.1 6 2.1 5.8 8 0 .3-1.2-.6-5.8.2-6-.7-5.7.8-5.8.3z"
        style={{
          fill: 'url(#radial-gradient-conv-4)',
        }}
      />
      <path
        d="M16.2 14c-5.9.6-9.2 2.4-9.2 2.4s-1.1.5-.9 2c.2 1.8.9 2.6.9 2.6l-.5.3.1 1.4-.3.3 4.8.9c3.1 0 9.2-.1 9.2-.2s17.8 0 26.8 0l10.8-.7c3.8-.5 5.8-3.1 6.2-4 .3-.9.4-1.6.2-2.9-.1-.7-.8-1.9-1.8-2.4-1.5-.8-7.7-1.8-7.7-1.8s-1.3.9-8 1.2c-5.4.2-11.6.5-17.8.5-6.6 0-8.7 0-12.8.4z"
        style={{ fill: 'none', stroke: '#007ee5', strokeWidth: '.15' }}
      />
      <path
        d="M16.4 17.2c-2.3 0-4.2 1.9-4.2 4.2 0 2.3 1.9 4.2 4.2 4.2s4.2-1.9 4.2-4.2c0-2.4-1.9-4.2-4.2-4.2zm0 7.4c-1.8 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.3 3.3-3.3s3.3 1.5 3.3 3.3c0 1.8-1.5 3.3-3.3 3.3zM52.5 17c-2.4 0-4.4 1.9-4.4 4.2 0 2.3 1.9 4.2 4.4 4.2s4.4-1.9 4.4-4.2c-.1-2.3-2-4.2-4.4-4.2zm0 7.6c-1.9 0-3.4-1.5-3.4-3.3s1.5-3.3 3.4-3.3 3.4 1.5 3.4 3.3-1.6 3.3-3.4 3.3z"
        style={{ fill: '#f0f6ff' }}
      />
      <path
        d="M52.5 25.9c-2.6 0-4.7-2.1-4.7-4.6 0-2.5 2.1-4.6 4.7-4.6s4.7 2.1 4.7 4.6c0 2.5-2.1 4.6-4.7 4.6zm0-8.5c-2.2 0-4 1.7-4 3.9s1.8 3.9 4 3.9 4-1.7 4-3.9-1.8-3.9-4-3.9zm-36.1 8.5c-2.5 0-4.6-2-4.6-4.5s2.1-4.5 4.6-4.5c2.5 0 4.6 2 4.6 4.5s-2.1 4.5-4.6 4.5zm0-8.3c-2.1 0-3.8 1.7-3.8 3.8 0 2.1 1.7 3.8 3.8 3.8 2.1 0 3.8-1.7 3.8-3.8 0-2.1-1.7-3.8-3.8-3.8z"
        className="icon-convert-st9"
      />
      <path
        d="M21.6 23.6c0 .1-.3 0-1.3.1.4-.7.7-1.5.7-2.3 0-2.5-2.1-4.5-4.6-4.5-2.5 0-4.6 2-4.6 4.5 0 .9.3 1.8.8 2.5-1.3 0-1.4.1-1.5-.2-.6-5.6 2.6-7.5 5.3-7.5 2.7.1 5.6 1.8 5.2 7.4zm30.9-7.8c-2.7-.1-5.9 2.1-5.4 7.7 0 .3.1.1 1.2 0-.4-.7-.6-1.4-.6-2.3 0-2.5 2.1-4.6 4.7-4.6s4.7 2.1 4.7 4.6c0 .7-.2 1.3-.4 1.9.7-.1.9-.1 1-.2.4-5.5-2.5-7-5.2-7.1zm-32.8 5.5c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3 1.5 3.3 3.3 3.3 3.3-1.5 3.3-3.3zm36.2-.1c0-1.8-1.5-3.3-3.4-3.3s-3.4 1.5-3.4 3.3 1.5 3.3 3.4 3.3 3.4-1.4 3.4-3.3z"
        style={{ fill: '#091a33' }}
      />
      <path
        d="M16.5 22.7v2.2m-1.1-3-2.1.7m2.5-2-1.3-1.8m2.7 1.8 1.3-1.8m-.9 3.1 2.1.7"
        style={{
          fill: 'none',
          stroke: '#cce0ff',
          strokeWidth: '.375',
          strokeLinecap: 'round',
        }}
      />
      <path
        d="M52.8 22.6v2.2m-1.2-3-2.2.7m2.7-2-1.4-1.8m2.8 1.8 1.4-1.8m-1 3.1 2.2.7"
        style={{
          fill: 'none',
          stroke: '#f0f6ff',
          strokeWidth: '.375',
          strokeLinecap: 'round',
        }}
      />
      <path
        d="M31.2 13.6s-1.3.5-1.6 2.3c-.4 2.1-.1 5.3 0 6 0 .1.1.1.2.1 6.1-.1 8.7-.3 13.5-.9.7-.1 1.4-.6 1.7-1.2 1-2.1 1.6-3.6 1.6-5.5-.1-.7-1.1-1-1.1-1"
        style={{ fill: 'none', stroke: '#002544', strokeWidth: '7.500000e-02' }}
      />
      <path
        d="m47.9 11.4.4 1.6c2.5-.2 4.5-.1 6.5-1.1-2.5-.3-3.7-.7-6.9-.5zm-9.7-1.6L37.1 9c.6.3 2 .8 2 .9.1.1 0 .3 0 .4-1.7.9-2.8 1.7-4.1 2.8l8.9-.3.1-2.4.6-.1.1-.3h.7l.6 1.4V10h.5l.4.9V10h.7l.7 3.1-15 .5c1.7-1.5 2.8-2.7 4.9-3.8zm-1.3 0-1.6-.3s-1.7.8-3 1.6c-1.5.9-3.4 2.4-3.4 2.4.8 0 3 .1 3.2.1.4-.1 2.2-2.1 4.8-3.8zM7 18.5c-.1-.7-.6-1.4-.6-1.4s-.4.5-.3 1.5c.1.7.8 1.3.8 1.3s.2-.7.1-1.4zm31 4c-3.7 0-14.7.7-14.7.7 8.5 0 14.8 0 22.2-.3.1 0-4.5-.4-7.5-.4zM8.2 19.9H6.9s.8 2.4 1.3 3c.2.3 1 .1 1 .1 0-1.2-.2-2-1-3.1zm20.2-4.1c-.3 0-3.5.2-3.7.3-.3.2-.5.4-.5.6 0 .2 1.1.9 1.8 1.3.3.1 2.6-.2 2.8-.3.2-.1.2-.2.3-.4 0-.2 0-1-.1-1.3-.2-.2-.4-.2-.6-.2zm34.2-1.3c-.4 0-4.3 0-4.6.1-.4.1.8 1 1.5 1.3.4.2 3.6 0 4.1-.2.2-.1-.7-1.2-1-1.2zM7.5 17.6c-.1.6 0 .9.1 1.1 0 0 1.1.1 1.9-.5.9-.6 1.8-1.6 2.5-2.3.1-.1 0-.3-.1-.3-.4 0-1 0-1.3.1-.6.2-3 1.3-3.1 1.9z"
        className="icon-hatch-st9"
      />
      <path
        d="M25.4 17h2.8"
        style={{
          fill: 'none',
          stroke: '#cce0ff',
          strokeWidth: '.35',
          strokeLinecap: 'round',
        }}
      />
    </symbol>
  </Fragment>
);
export const iconConvertible = (
  <svg
    aria-hidden
    key="iconConvertible"
    xmlns="http://www.w3.org/2000/svg"
    width={71}
    height={27}
    className="mt-0_5 mb-0_5"
  >
    <use xlinkHref="#icon-convertible" />
  </svg>
);

export const iconSedanSymbol = (
  <Fragment key="iconSedanSymbol">
    <defs>
      <radialGradient
        id="radial-gradient-sedan"
        cx={134.941}
        cy={418.834}
        r={1}
        gradientTransform="matrix(0 .9433 30.5625 0 -12766.022 -101.74)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#091a33' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </radialGradient>
      <linearGradient
        id="radial-gradient-sedan-2"
        x1={39.135}
        x2={39.135}
        y1={20.011}
        y2={14.55}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#4e91f5' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </linearGradient>
    </defs>
    <symbol id="icon-sedan" viewBox="0 0 71 27">
      <path
        d="M18.1 25.5c.6-.6 1.2-1.2 1.9-2.2h-1.6l-1.9 2.2h1.6zm32.1 0c-.6-.6-1.2-1.2-1.9-2.2h1.6l1.9 2.2h-1.6z"
        className="st0"
      />
      <ellipse cx={34.6} cy={25.6} rx={30.6} ry=".9" style={{ fill: 'url(#radial-gradient-sedan)' }} />
      <path
        d="m58.8 22.5 7.2-1.2c.7-1.6.9-2.6.9-4.5l-1.3-.9.8-.9-.5-.6.5-.3c0-.6-.1-1.2-.2-1.8l-6.6-.9c-4.9-2-7.6-3.3-11.8-4-4.1-.8-12-.2-15.4.6s-5.6 2.5-8.8 4.5c-6.4.4-12.2 1.2-17.3 2.4l-1.6 1.5v1.2l-.7.7c-.1 1.6 0 2.5.3 4.2l6 .9 48.5-.9z"
        style={{ fill: '#fff' }}
      />
      <path
        d="M23.2 20.9c8 0 23.4-.3 40.9-.9l2.5-.1-.9 1.9-3 .7-44 1.2V19h2l1.5 1.4c.3.3.6.5 1 .5z"
        style={{ fill: '#9fd4ff' }}
      />
      <path
        d="m58.8 22.8 7.2-1.3c.7-1.7.9-2.8.9-4.8l-1.3-1 .8-1-.5-.6c.1.7 0-.6 0 0 0 0-2.8.3-4.9.7-2.3.5-3.9 1.1-6.5 1.5-4.2.9-7.8-1.2-10.8-.9-20.8 1-26 2.2-32.2.3-2-.3-7 .4-7 .4v1.6l-.5.6c-.1 1.7 0 2.7.4 4.5l6 1 24.2-.5 24.2-.5z"
        style={{ fill: '#cce0ff' }}
      />
      <path
        d="M45.1 19.9c-9.7.6-17.1.9-21.5.9-.3 0-.7-.1-.9-.3l-2-1.5"
        style={{
          fill: 'none',
          stroke: '#4e91f5',
          strokeWidth: '.5',
          strokeLinecap: 'round',
        }}
      />
      <path
        d="m58.8 22.5 7.2-1.2c.7-1.6.9-2.6.9-4.5l-1.3-.9.8-.9-.5-.6.5-.3c0-.6-.1-1.2-.2-1.8l-6.6-.9c-4.9-2-7.6-3.3-11.8-4-4.1-.8-12-.2-15.4.6-3.2.8-5.4 2.4-8.4 4.3-.3.2-.6.3-.9.3-6.2.4-11.9 1.1-16.9 2.4l-1.6 1.5v1.2l-.6.6c-.1 1.6 0 2.5.3 4.2l6 .9 24.2-.5 24.3-.4z"
        style={{ fill: 'none', stroke: '#007ee5', strokeWidth: '.175' }}
      />
      <path
        d="m18.2 16.1-1.1-.6c14.6-1 25.1-1.2 48.1-1.2-17.8.6-27.9 1-45.5 2.2-.6 0-1.1-.1-1.5-.4z"
        style={{ fill: '#7aafff' }}
      />
      <path d="m66.1 21.9-7.2 1.2-24.2.5-24.4.4-6-.9" style={{ fill: 'none', stroke: '#091a33', strokeWidth: '.5' }} />
      <path
        d="M24.8 13.4c12.3-.9 15.1-.9 27.7-1.2 0 0 1.6-.6.6-2.1-.9-1.4-10.8-2.7-16.3-1.9-.5.1-1 .2-1.5.2-.8.1-2.1.4-3.3.8-1.8.6-4.7 2.1-7.2 4.2z"
        style={{
          fill: 'url(#radial-gradient-sedan-2)',
        }}
      />
      <path
        d="M37.4 12.4c1.4 0 1.3 0 2.6-.1 0 0 .1-.5-.1-1-.1-.5-.3-.5-1.3-.5-.2 0-.4.2-.4.2-.3.2-.5.8-.8 1.4zm0 0c1.4 0 1.3 0 2.6-.1 0 0 .1-.5-.1-1-.1-.5-.3-.5-1.3-.5-.2 0-.4.2-.4.2-.3.2-.5.8-.8 1.4zm0 0c1.4 0 1.3 0 2.6-.1 0 0 .1-.5-.1-1-.1-.5-.3-.5-1.3-.5-.2 0-.4.2-.4.2-.3.2-.5.8-.8 1.4zm12.1-.2h2.4s.5-.4.5-.7c0-.3-1.1-.9-1.8-.7-.1 0-.1 0-.2.1-.1 0-.2.1-.4.2s-.3.3-.5 1.1zm0 0h2.4s.5-.4.5-.7c0-.3-1.1-.9-1.8-.7-.1 0-.1 0-.2.1-.1 0-.2.1-.4.2s-.3.3-.5 1.1zm0 0h2.4s.5-.4.5-.7c0-.3-1.1-.9-1.8-.7-.1 0-.1 0-.2.1-.1 0-.2.1-.4.2s-.3.3-.5 1.1z"
        style={{ fill: '#004680' }}
      />
      <path
        d="M14.7 25.1c-2.4 0-4.4-1.9-4.4-4.2 0-2.3 2-4.2 4.4-4.2 2.4 0 4.4 1.9 4.4 4.2 0 2.3-2 4.2-4.4 4.2zm39.7 0c-2.4 0-4.4-1.9-4.4-4.2 0-2.3 2-4.2 4.4-4.2 2.4 0 4.4 1.9 4.4 4.2 0 2.3-2 4.2-4.4 4.2z"
        style={{ fill: '#fff', stroke: '#033e96', strokeWidth: '.75' }}
      />
      <path
        d="M14.7 24.2c-1.9 0-3.5-1.5-3.5-3.3 0-1.8 1.6-3.3 3.5-3.3s3.5 1.5 3.5 3.3c0 1.8-1.6 3.3-3.5 3.3zm39.7 0c-1.9 0-3.5-1.5-3.5-3.3 0-1.8 1.6-3.3 3.5-3.3s3.5 1.5 3.5 3.3c-.1 1.8-1.6 3.3-3.5 3.3z"
        className="st0"
      />
      <path
        d="M14.7 22.5V25m1.1-3 2 1.6M16 20.9l2.4-.6m-3.1-.3 1.1-2.3M14.2 20l-1.1-2.3m.4 3.2-2.5-.6m2.7 1.7-2 1.6m42.7-1.1V25m1-3 2 1.6m-1.7-2.7 2.4-.6M55 20l1.1-2.3M53.8 20l-1.1-2.3m.4 3.2-2.5-.6m2.8 1.7-2 1.6"
        style={{ fill: 'none', stroke: '#fff', strokeWidth: '.5' }}
      />
      <path
        d="m40.2 7.1-1.3 5.6c-.4.7-1.1 1.5-.9 2.5.2 1-.4 1.9-.4 8m-12.3-10c-1 .8-1.5 1-1.6 1.9.6 1.2-.7 2.4.3 8.3m28.2-11.1c-1.5 3.8-3.5 7.5-6.4 11"
        style={{ fill: 'none', stroke: '#007ee5', strokeWidth: '.125' }}
      />
    </symbol>
  </Fragment>
);
export const iconSedan = (
  <svg aria-hidden key="iconSedan" xmlns="http://www.w3.org/2000/svg" width={71} height={27} className="mt-0_5 mb-0_5">
    <use xlinkHref="#icon-sedan" />
  </svg>
);

export const iconHybridSymbol = (
  <Fragment key="iconHybridSymbol">
    <defs>
      <radialGradient
        id="radial-gradient-hybrid"
        cx={138.666}
        cy={419.006}
        r={1}
        gradientTransform="matrix(0 .9347 29.9787 0 -12525.8 -103.553)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#091a33' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </radialGradient>
      <linearGradient
        id="radial-gradient-hybrid-2"
        x1={39.419}
        x2={39.419}
        y1={20.389}
        y2={13.665}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#7aafff' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </linearGradient>
      <linearGradient
        id="radial-gradient-hybrid-3"
        x1={22.4}
        x2={22.4}
        y1={17.741}
        y2={12.996}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#54b1fe' }} />
        <stop offset=".516" style={{ stopColor: '#005fac' }} />
        <stop offset={1} style={{ stopColor: '#003159' }} />
      </linearGradient>
      <linearGradient
        id="radial-gradient-hybrid-4"
        x1={38.565}
        x2={38.565}
        y1={20.334}
        y2={14.613}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#54b1fe' }} />
        <stop offset=".516" style={{ stopColor: '#005fac' }} />
        <stop offset={1} style={{ stopColor: '#003159' }} />
      </linearGradient>
      <linearGradient
        id="radial-gradient-hybrid-5"
        x1={54.648}
        x2={54.648}
        y1={18.818}
        y2={16.281}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#0070cc' }} />
        <stop offset=".516" style={{ stopColor: '#005fac' }} />
        <stop offset={1} style={{ stopColor: '#003159' }} />
      </linearGradient>
    </defs>
    <symbol id="icon-hybrid" viewBox="0 0 71 27">
      <path
        d="M19 26.1c.7-.7 1.3-1.3 2-2.3h-1.7l-2 2.3H19zm31.1 0c-.7-.7-1.3-1.3-2-2.3h1.7l2 2.3h-1.7z"
        style={{ fill: '#091a33' }}
      />
      <ellipse cx={35.5} cy={26.1} rx={30} ry=".9" style={{ fill: 'url(#radial-gradient-hybrid)' }} />
      <path
        d="M61.5 10.9h2.7l-.6 2.1s.5 1.1.8 3.5l.9 2.4c.2 1.5 0 2.3-.6 2.6-1.1.7-6.7 1.7-6.7 1.7l-7.6.8-30.8.4h-7.1s-8-.9-7.4-1.2.3-2.8.5-4.9l1.2-.7L8 16.5c.3-.3.7-.6 1.2-.7 3.3-1.2 4.5-1.4 8.5-2.3.7-.2 1.4-.4 2.1-.7 4.7-2.3 10.7-4.8 13.7-5.3 3.2-.6 8.1-.6 12.2 0 3.8.5 7.8 1.5 13.8 3.1.6.2 1.3.3 2 .3z"
        style={{ fill: '#fff' }}
      />
      <path
        d="m59.5 14.1 4.4-.3s.3.3.6 2.6l.9 2.4c.2 1.5 0 2.3-.6 2.6-1.1.7-6.7 1.7-6.7 1.7l-7.3.9-31.1.3h-7.1L8 23.8l-2.9-.5s.4-1.3.3-2.4c-.1-1.1.1-2.5.1-2.5l.9-.5 6.6.5 2.7-.3c.3 0 .5-.1.8-.2l1.9-.7c.8-.3 1.6-.5 2.5-.5l11.3-1 13.6-1.1c.1-.2 6.8.2 13.7-.5z"
        style={{ fill: '#cce0ff' }}
      />
      <path
        d="M12.5 24.4s-8-.9-7.4-1.2.3-2.8.5-4.9l1.2-.7L8 16.5c.3-.3.7-.6 1.2-.7 3.3-1.2 4.5-1.4 8.5-2.3.7-.2 1.4-.4 2.1-.7 4.7-2.3 10.7-4.8 13.7-5.3 3.2-.6 8.1-.6 12.2 0 3.8.5 7.8 1.5 13.8 3.1.7.2 1.3.3 2 .3h2.8l-.7 2.1s.5 1.1.8 3.5l.9 2.4c.2 1.5 0 2.3-.6 2.6-1.1.7-6.7 1.7-6.7 1.7m-7.6.8-31.2.4"
        style={{ fill: 'none', stroke: '#007ee5', strokeWidth: '.175' }}
      />
      <path
        d="M52.6 11.9c4.1-.5 5.9-.7 5.9-.7-4.9-1.7-9.6-2.5-15.3-3.2-5.9-.5-7.3-.4-9.8.1-3.2.6-8.2 2.8-12.7 5.4-.5.3-.5 1 0 1.3l.4.2s27.4-2.6 31.5-3.1z"
        style={{
          fill: 'url(#radial-gradient-hybrid-2)',
        }}
      />
      <path
        d="M36.2 13.4c1.4-.3 1.8-.3 3.3-.4 0 0 .2-.2.1-.8-.1-.5-1.3-1-1.9-.7-.1 0-.1.1-.2.1-.1.1-.3.1-.4.3-.3.2-.6.7-.9 1.5zm0 0c1.4-.3 1.8-.3 3.3-.4 0 0 .2-.2.1-.8-.1-.5-1.3-1-1.9-.7-.1 0-.1.1-.2.1-.1.1-.3.1-.4.3-.3.2-.6.7-.9 1.5zm0 0c1.4-.3 1.8-.3 3.3-.4 0 0 .2-.2.1-.8-.1-.5-1.3-1-1.9-.7-.1 0-.1.1-.2.1-.1.1-.3.1-.4.3-.3.2-.6.7-.9 1.5zM51.4 12c1.4-.3 1.8-.3 3.3-.4 0 0 .2-.2.1-.8-.1-.5-1.3-1-1.9-.7-.1 0-.1.1-.2.1-.1.1-.3.1-.4.3-.2.2-.6.7-.9 1.5zm0 0c1.4-.3 1.8-.3 3.3-.4 0 0 .2-.2.1-.8-.1-.5-1.3-1-1.9-.7-.1 0-.1.1-.2.1-.1.1-.3.1-.4.3-.2.2-.6.7-.9 1.5zm0 0c1.4-.3 1.8-.3 3.3-.4 0 0 .2-.2.1-.8-.1-.5-1.3-1-1.9-.7-.1 0-.1.1-.2.1-.1.1-.3.1-.4.3-.2.2-.6.7-.9 1.5z"
        style={{ fill: '#004680' }}
      />
      <path
        d="M24.3 11.4c-1.3.7-2.4 1.2-3.5 2-.4.3-.4.8-.1 1.1l.2.2.2.2 2.6-.3.6-3.2z"
        style={{
          fill: 'url(#radial-gradient-hybrid-3)',
        }}
      />
      <path
        d="M39.9 7.8h-1.5l-1.2 5.6 2.4-.2.3-5.4z"
        style={{
          fill: 'url(#radial-gradient-hybrid-4)',
        }}
      />
      <path
        d="m55.1 10.2-4.2-1 1.5 2.7 6-.7-3.3-1z"
        style={{
          fill: 'url(#radial-gradient-hybrid-5)',
        }}
      />
      <path
        d="m39.2 7.7-.6 5.6c-.4 1.4-.2 6.1-.1 8.5 0 .8-.6 1.5-1.4 1.6-3 .1-9.6.4-14.4.4-.3 0-.5-.2-.5-.4-.5-4.3-.5-5.7-.3-8 .3-2.3.6-2.9.6-2.9m29.9-.6c.7 1.4.8 1.8-3.5 8.2"
        style={{ fill: 'none', stroke: '#007ee5', strokeWidth: '7.500000e-02' }}
      />
      <path
        d="M19.4 24s17.1.1 20.1-.6 11.1-4 11.1-4l7 1.1 7.6-2 .3 1.3-.4 1.9-7.4 1.8-7.6.5-30.7.4V24zm21.2-9.9 23-2.3-.3.9-22.7 1.4zm1.7 7-22.6 2.6v-1.1l22.6-1.5z"
        style={{ fill: '#2070e8' }}
      />
      <path
        d="m65.5 21.8-6.9 1.7m-8.1.8-31.3.4M5 23.5l6.7 1.1"
        style={{
          fill: 'none',
          stroke: '#091a33',
          strokeWidth: '.5',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="M11 22c0-2.4 1.9-4.3 4.4-4.3s4.4 1.9 4.4 4.3-1.9 4.3-4.4 4.3S11 24.4 11 22zm38.7 0c0-2.4 1.9-4.3 4.4-4.3s4.4 1.9 4.4 4.3-1.9 4.3-4.4 4.3-4.4-1.9-4.4-4.3z"
        style={{ fill: '#f0f6ff', stroke: '#091a33', strokeWidth: '.75' }}
      />
      <path
        d="M15.4 25.4c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.4 3.4-3.4 3.4 1.5 3.4 3.4-1.6 3.4-3.4 3.4zm38.6 0c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.4 3.4-3.4 3.4 1.5 3.4 3.4-1.5 3.4-3.4 3.4z"
        style={{ fill: '#033e96' }}
      />
      <path
        d="M15.5 23.2v2.2m-1.2-3-2.2.7m2.6-2-1.4-1.8m2.9 1.8 1.4-1.8m-1 3.1 2.2.7m35.7.1v2.2m-1.2-3-2.2.7m2.6-2-1.4-1.8m2.9 1.8 1.4-1.8m-1 3.1 2.2.7"
        style={{
          fill: 'none',
          stroke: '#f0f6ff',
          strokeWidth: '.375',
          strokeLinecap: 'round',
        }}
      />
    </symbol>
  </Fragment>
);
export const iconHybrid = (
  <svg aria-hidden xmlns="http://www.w3.org/2000/svg" width={71} height={27} className="mt-0_5 mb-0_5">
    <use xlinkHref="#icon-hybrid" />
  </svg>
);

export const iconEvSymbol = (
  <Fragment key="iconEvSymbol">
    <defs>
      <linearGradient
        id="radial-gradient-ev"
        x1={36.337}
        x2={36.337}
        y1={20.837}
        y2={15.721}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#7aafff' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </linearGradient>

      <linearGradient
        id="radial-gradient-ev-2"
        x1={57.522}
        x2={57.522}
        y1={19.311}
        y2={16.559}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#2070e8' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </linearGradient>

      <radialGradient
        id="radial-gradient-ev-3"
        cx={162.929}
        cy={419.189}
        r={1}
        gradientTransform="matrix(0 .8824 29.3836 0 -12283.252 -117.645)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#091a33' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </radialGradient>
    </defs>
    <symbol id="icon-ev" viewBox="0 0 71 27">
      <path
        d="M65.4 8v8.2c0 .9-.7 1.6-1.6 1.6h0m2.6-13.4V2.5m-2.1 1.9V2.5"
        style={{
          fill: 'none',
          stroke: '#a3c8ff',
          strokeWidth: '.5',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="M67 5.6c.3 0 .5.2.5.5v3.3c0 1-1 1.8-2.1 1.9-1.2 0-2.1-.8-2.1-1.9V6.1c0-.3.2-.5.5-.5H67z"
        style={{ fillRule: 'evenodd', clipRule: 'evenodd', fill: '#4e91f5' }}
      />
      <path
        d="m65.6 6.5-1.9 1.3c-.1 0-.1.2 0 .2h2c.1 0 .2.2.1.2l-2 1.6"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeWidth: '.5',
          strokeLinecap: 'round',
        }}
      />
      <path
        d="M18.7 12.5c4.7-2.7 8-4.1 12.7-5.5 4.7-1.3 13.1-.6 24.6 1.2l-.8.5 2.9 1.4 2.9 1.4 2.5.5-.6 1.9c.6 2.1.6 3.3.3 5.5l.6 1.1-.8 1.9-5.7 1-7.6.9s-4.9-.4-7.4-.5c-2.5-.1-24.3 0-24.3 0l-7.8.2H5.7L4 22.7l1.1-1.1v-.8l-.8-.5-.3-2 .8-.8-.3-1.1c2.8-1.9 5.9-3.3 14.2-3.9z"
        style={{ fill: '#fff' }}
      />
      <path
        d="M47.9 11.4C50.8 11 54.1 9 54.1 9S34.5 6.1 30 7.6s-7.3 2.8-11.4 5c0 .4 26.5-.7 29.3-1.2z"
        style={{ fill: 'url(#radial-gradient-ev)' }}
      />
      <path
        d="m19.8 17.3-1.1.6.7 4.6 28.2-1.3.6-4.7-4.1-.6c-.4-.1-.9-.1-1.3-.1l-19.8.6c-1.1 0-2.2.3-3.2.9zm23.7 4.2c3.6-.5 14.3-6 19.8-9.4l-.5 1.8c.5 2.2.5 3.3.2 5.4l.5 1.1-.5 1.8-5.4 1.1-9 .9s-4.7-.6-6.4-.6c-1.9.1-36.6.4-36.6.4L4 22.6l16-.3c0 .1 19.9-.2 23.5-.8z"
        style={{ fill: '#cce0ff' }}
      />
      <path
        d="M63.1 19.1c.3-2.2.4-3.1-.2-5.2l.6-1.9-2.5-.5-3-1.4-2.9-1.4.9-.5C44.5 6.4 36.1 5.7 31.4 7.1s-8.1 2.8-12.7 5.5c-8.3.5-11.3 1.9-14.1 3.8l.3 1.1-.9.8.3 1.9.8.5v.8L4 22.7"
        style={{ fill: 'none', stroke: '#007ee5', strokeWidth: '.25' }}
      />
      <path
        d="m54 9 .9-.3 6.1 2.9h-1.2L54 9z"
        style={{
          fill: 'url(#radial-gradient-ev-2)',
        }}
      />
      <path
        d="M63.4 12.1c-5.5 3.4-16.3 8.9-19.8 9.5-3.6.5-25.1.8-25.1.8L4 22.6"
        style={{ fill: 'none', stroke: '#0069bf', strokeWidth: '.175' }}
      />
      <ellipse
        cx={34}
        cy={26.1}
        rx={29.4}
        ry=".9"
        style={{
          fill: 'url(#radial-gradient-ev-3)',
        }}
      />
      <path
        d="M33.7 12c1.3 0 1.6-.1 3-.1 0 0 .6-.7.5-1.2-.1-.5-1.2-.9-1.8-.7-.1 0-.1.1-.2.1s-.2.1-.4.3c-.2.2-.8.9-1.1 1.6zm0 0c1.3 0 1.6-.1 3-.1 0 0 .6-.7.5-1.2-.1-.5-1.2-.9-1.8-.7-.1 0-.1.1-.2.1s-.2.1-.4.3c-.2.2-.8.9-1.1 1.6zm0 0c1.3 0 1.6-.1 3-.1 0 0 .6-.7.5-1.2-.1-.5-1.2-.9-1.8-.7-.1 0-.1.1-.2.1s-.2.1-.4.3c-.2.2-.8.9-1.1 1.6zm13.5-.6c1.3-.2 1.1-.2 2.5-.4 0 0 .4-.7.2-1.1-.1-.3-1.4-.5-1.6-.4-.1 0-.1.1-.1.1l-.3.3c-.3.2-.5.8-.7 1.5zm0 0c1.3-.2 1.1-.2 2.5-.4 0 0 .4-.7.2-1.1-.1-.3-1.4-.5-1.6-.4-.1 0-.1.1-.1.1l-.3.3c-.3.2-.5.8-.7 1.5zm0 0c1.3-.2 1.1-.2 2.5-.4 0 0 .4-.7.2-1.1-.1-.3-1.4-.5-1.6-.4-.1 0-.1.1-.1.1l-.3.3c-.3.2-.5.8-.7 1.5z"
        style={{ fill: '#004680' }}
      />
      <path
        d="M66.4 4.4V2.5v1.9zm-2.1 0V2.5v1.9zM18 15.6l-.5-.3c10.5-.9 18-1.1 34.4-1-12.7.5-20.1.4-32.6 1.5-.4 0-.9-.1-1.3-.2z"
        style={{ fill: '#4e91f5' }}
      />
      <path
        d="m36.5 7.4-1.2 4.9c-.9 1.6-1.2 4.9-1 9.7m-14-9.4c-.7 3.2-.9 5.5 0 9.6m28.3-11s1.9 1.9 1.9 4.2"
        style={{ fill: 'none', stroke: '#007ee5', strokeWidth: '.125' }}
      />
      <path
        d="M20 22.4s20.7-.4 23.5-.9c1.4-.2 5-1.8 8.9-2.3 4.1 1.1 8.3.3 10.6-.1l.5 1.2-.5 1.9-5.4 1.2-9 .9s-4.2-.5-6-.5c-1.8 0-36.5.5-36.5.5L4 22.7l16-.3zM7 20.9c.3-3.7 3.6-6.4 7.3-6.1 3.7.3 6.5 3.5 6.1 7.2-.2 2.5-.4 2.2-8.5 2.7-4.6-.3-5.2-.1-4.9-3.8zm39.2.2c0-3.5 3-6.3 6.7-6.3s6.7 2.8 6.7 6.3c0 2.4-1 2.1-8.2 3.2-4-.3-5.2.3-5.2-3.2z"
        style={{ fill: '#033e96' }}
      />
      <path
        d="M13.7 25.6c-2.5 0-4.6-2-4.6-4.6s2.1-4.6 4.6-4.6 4.6 2 4.6 4.6-2.1 4.6-4.6 4.6zm39.2.4c-2.5 0-4.6-2-4.6-4.6s2.1-4.6 4.6-4.6 4.6 2 4.6 4.6-2 4.6-4.6 4.6z"
        style={{ fill: '#d6edff', stroke: '#091a33', strokeWidth: '.75' }}
      />
      <path
        d="M49.3 25.6c-1.4-.7-1.7-.8-2.2-1.6h1.4l2.5 1.6h-1.7zm-32.6 0c1.4-.7 1.7-.8 2.2-1.6h-1.4L15 25.6h1.7zm-2.9-1.1c-1.9 0-3.5-1.5-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.5 3.5 3.5-1.6 3.5-3.5 3.5zm39.5.4c-1.9 0-3.5-1.5-3.5-3.5 0-1.9 1.6-3.5 3.5-3.5s3.5 1.5 3.5 3.5-1.6 3.5-3.5 3.5z"
        style={{ fill: '#091a33' }}
      />
      <path
        d="m13.8 22 .2 2.5c0 .2-.1.3-.3.3l-2-.6 1.4-.6.3-.3.4-1.3zm-1-.6-2.4 1c-.2.1-.3-.1-.3-.2v-2l1 1.1c.1.1.2.2.4.2l1.3-.1zm.3-1.1-1.7-1.9c-.1-.1-.1-.3.1-.4l1.9-.6-.8 1.2c-.1.1-.1.3 0 .4l.5 1.3zm1.2-.1 1.3-2.1c.1-.1.3-.2.4 0l1.2 1.6-1.5-.3c-.1 0-.3 0-.4.1l-1 .7zm.5 1 2.5.6c.2 0 .3.2.1.4l-1.2 1.6-.1-1.4c0-.2-.1-.3-.2-.4l-1.1-.8zm38.6 1.2.2 2.5c0 .2-.1.3-.3.3l-2-.6 1.4-.6.3-.3.4-1.3zm-1-.6-2.4 1c-.2.1-.3-.1-.3-.2v-2l1 1.1c.1.1.2.2.4.2l1.3-.1zm.3-1.1L51 18.9c-.1-.1-.1-.3.1-.4l1.9-.6-.8 1.2c-.1.1-.1.3 0 .4l.5 1.2zm1.1-.1 1.3-2.1c.1-.1.3-.2.4 0l1.2 1.6-1.5-.3c-.1 0-.3 0-.4.1l-1 .7zm.5 1.1 2.5.6c.2 0 .3.2.1.4l-1.2 1.6-.1-1.4c0-.2-.1-.3-.2-.4l-1.1-.8z"
        style={{ fill: '#addbff' }}
      />
    </symbol>
  </Fragment>
);
export const iconEv = (
  <svg aria-hidden key="iconEv" xmlns="http://www.w3.org/2000/svg" width={71} height={27} className="mt-0_5 mb-0_5">
    <use xlinkHref="#icon-ev" />
  </svg>
);

export const iconTruckSymbol = (
  <Fragment key="iconTruckSymbol">
    <defs>
      <radialGradient
        id="radial-gradient-truck"
        cx={148.729}
        cy={417.714}
        r={1}
        gradientTransform="matrix(0 .9123 35 0 -14584 -110.096)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#091a33' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </radialGradient>
      <linearGradient
        id="radial-gradient-truck-2"
        x1={31.817}
        x2={32.053}
        y1={25.201}
        y2={19.63}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#4e91f5' }} />
        <stop offset={1} style={{ stopColor: '#003866', stopOpacity: '.85' }} />
        <stop offset={1} style={{ stopColor: '#091a33' }} />
      </linearGradient>
    </defs>
    <symbol id="icon-truck" viewBox="0 0 71 27">
      <style
        dangerouslySetInnerHTML={{
          __html: '.icon-truck-st3{fill:#cce0ff}.icon-truck-st4{fill:#f0f6ff}.icon-truck-st5{fill:#033e96}',
        }}
      />
      <path d="M0 0h71v27H0z" style={{ fill: 'none' }} />
      <path
        d="M16.7 25.1c1.5-1.5 2-2.4 2.6-4.5l-2.4-.2-5.4 5.2 5.2-.5zm36.5 0c-1.5-1.5-2-2.4-2.6-4.5l2.4-.2 5.4 5.2-5.2-.5z"
        style={{ fill: '#004781' }}
      />
      <ellipse cx={36} cy={25.6} rx={35} ry=".9" style={{ fill: 'url(#radial-gradient-truck)' }} />
      <path
        d="m63.3 20.5 6.8-2.4c.4-.1.6-.4.7-.8l.3-2.2-.4-.3.4-3.7-.3-.3V8.9c0-.6-.5-1-1-1L50.4 8c-.3 0-.5-.2-.5-.5l-.2-4.3c0-.5-.4-.9-.9-.9-2-.1-6.8-.3-11.2-.3-4.1 0-7.7.2-9.4.3-.7 0-1.4.3-2 .7l-7.1 5c-.6.4-1.2.6-1.9.6-7.1.2-10.4.7-14.5 1.5-.4 0-.7.4-.8.9l-.2 3.5.3.9v1l-.4.3v1.6c0 .4.2.7.5.9l3.9 2 11.8-.4h34.6l10.9-.3z"
        className="icon-truck-st3"
      />
      <path
        d="M47.6 4.1v4.1c0 .9-.3 1.7-.8 2.5L44 14.4c-.6.7-1.4 1.2-2.4 1.2L2 15.4c-.3-2-.2-4.4.2-5.3 4.9-1.2 8.4-1.4 16.3-1.7l22.8-.1c.8 0 1.6-.2 2.3-.6l1.5-.8c.5-.3.8-.8.8-1.3V3.4c0-.2-.1-.4-.3-.4l1 .1c.6 0 1 .4 1 1zm22.9 4.1-.7-.4-19.9.1c0 .6.5 1 1 1l19.7-.2-.1-.5z"
        className="icon-truck-st4"
      />
      <path
        d="m63.6 20.6 6.4-2.4c.4-.1.6-.5.6-.9l.2-2.8s-1.2.9-1.9 1.3S58 18.2 58 18.2l-6.8-.7-40.5.5-4.5-2.7H4.8c-.3 0-.5-.2-.5-.5v-2c0-.3-.2-.5-.5-.5h-2v2.2l.3.9v1l-.6.4v1.6c0 .4.2.7.5.9l4.5 2.4 11.3-.7h34.6l11.2-.4z"
        className="icon-truck-st5"
      />
      <path
        d="M4.5 20.6c.6-2.9 1.1-4.6 2.4-6.8.4-.8 1.1-1.2 1.9-1.3 2.2-.1 4.8 0 6.3 0 .8 0 1.6.5 2 1.3.7 1.5 1.9 4.3 2.4 7.2m31 0c.6-2.9 1.3-5 2.5-7.2.4-.7 1.1-1.2 1.9-1.2 2.1-.1 4.6 0 6 0 .8 0 1.6.5 1.9 1.2.7 1.3 1.7 3.7 2.1 6.4"
        style={{ fill: 'none', stroke: '#091a33', strokeWidth: '.5' }}
      />
      <path
        d="m45.8 7-2.9 1.6c-.4.3-.9.4-1.4.5l-14.1.2h-21c5.4-.6 8.1-.8 14-1L28 3l10-.2 7.9.2c.3 0 .5.2.5.5v2.7c-.1.3-.3.6-.6.8z"
        style={{ fill: '#fff' }}
      />
      <path
        d="M45.9 3.4v2.1c0 .6-.3 1.1-.8 1.3l-1.5.8c-.7.4-1.5.6-2.3.6L18 8.4l7.5-4.9c.5-.3 1.1-.5 1.8-.6 6.3-.2 11.8-.2 18.2 0 .2 0 .4.3.4.5z"
        style={{
          fill: 'url(#radial-gradient-truck-2)',
        }}
      />
      <path
        d="M34.2 8.1c-.7 1.9-.7 4.3-.4 9.5M20.3 8.4c-1 .7-1.1 2.1-1.2 3-.1 1.9-.1 3 .8 6.5"
        style={{ fill: 'none', stroke: '#007ee5', strokeWidth: '.125' }}
      />
      <path
        d="m70.9 14.5-.3-.4.5-3.2-.3-.3V8.7c0-.6-.5-1-1-1l-19.4.2c-.3 0-.5-.2-.5-.5l-.2-4c0-.5-.4-.9-.9-.9-1.9-.2-6.5-.5-10.9-.5-4.2 0-8 .2-9.8.2-.7 0-1.5.3-2.1.7l-6.9 4.8c-.6.4-1.2.6-1.9.6-7.1.3-10.4.8-14.5 1.6-.4.1-.7.5-.8.9l-.2 3.5.3.9v1l-.4.3"
        style={{ fill: 'none', stroke: '#007ee5', strokeWidth: '.175' }}
      />
      <path
        d="M57.9 25.9c3.2 0 5.9-2.6 5.9-5.8s-2.6-5.8-5.9-5.8c-3.2 0-5.9 2.6-5.9 5.8s2.7 5.8 5.9 5.8zm-46 0c3.2 0 5.9-2.6 5.9-5.8s-2.6-5.8-5.9-5.8S6 16.8 6 20.1s2.6 5.8 5.9 5.8z"
        className="icon-truck-st5"
      />
      <path
        d="M57.9 24.3c2.3 0 4.2-1.9 4.2-4.2s-1.9-4.2-4.2-4.2c-2.3 0-4.2 1.9-4.2 4.2s1.9 4.2 4.2 4.2zm-46 0c2.3 0 4.2-1.9 4.2-4.2s-1.9-4.2-4.2-4.2-4.2 1.9-4.2 4.2 1.8 4.2 4.2 4.2z"
        className="icon-truck-st3"
      />
      <path
        d="M17.2 13.8c.7 1.5 1.7 4.1 2.1 6.9h-1.6V20c0-3.2-2.6-5.8-5.9-5.8-3.2 0-5.9 2.6-5.9 5.8 0 .3 0 .6.1.9l-1.3-.6c.6-2.8 1.1-4.5 2.3-6.7.4-.7 1.1-1.1 1.9-1.2 2.1-.1 4.6 0 6.1 0 1 .1 1.8.6 2.2 1.4zM52 20.1c0-3.2 2.6-5.8 5.9-5.8 3.2 0 5.9 2.6 5.9 5.8v.4l1.2-.4c-.4-2.6-1.3-4.8-1.9-6.1-.4-.8-1.1-1.2-1.9-1.2-1.5 0-4-.1-6.2 0-.8 0-1.5.5-1.9 1.2-1.2 2.2-1.9 4.2-2.4 7H52.3c-.2-.4-.3-.7-.3-.9zm5.9 3.9c2.2 0 4-1.8 4-3.9s-1.8-3.9-4-3.9-4 1.8-4 3.9 1.8 3.9 4 3.9zm-46 0c2.2 0 4-1.8 4-3.9s-1.8-3.9-4-3.9-4 1.8-4 3.9 1.8 3.9 4 3.9z"
        style={{ fill: '#091a33' }}
      />
      <path
        d="M57.5 21.6c-.1 0-.2.1-.2.2v1.6c0 .1.1.2.2.2h.6c.1 0 .3-.1.3-.2v-1.6c0-.1-.1-.2-.2-.2h-.7zm1.4-.5c0 .1 0 .3.2.3l1.5.5c.1 0 .3 0 .3-.2l.2-.6c0-.1 0-.3-.2-.3l-1.5-.5c-.1 0-.3 0-.3.2l-.2.6zm0-1.6c.1.1.3.1.4-.1l1-1.3c.1-.1.1-.3-.1-.3l-.5-.4c-.1-.1-.3-.1-.4.1l-1 1.3c-.1.1-.1.3.1.3l.5.4zm-1.5-.3c.1-.1.1-.2.1-.3l-.9-1.3c-.1-.1-.2-.1-.3-.1l-.5.4c-.1.1-.1.2-.1.3l.9 1.3c.1.1.2.1.3.1l.5-.4zm-.8 1.2c0-.1-.2-.2-.3-.2l-1.5.5c-.1 0-.2.2-.2.3l.2.6c0 .1.2.2.3.2l1.5-.5c.1 0 .2-.2.2-.3l-.2-.6zm-45.1 1.2c-.1 0-.2.1-.2.2v1.6c0 .1.1.2.2.2h.6c.1 0 .3-.1.3-.2v-1.6c0-.1-.1-.2-.2-.2h-.7zm1.4-.5c0 .1 0 .3.2.3l1.5.5c.1 0 .3 0 .3-.2l.2-.6c0-.1 0-.3-.2-.3l-1.5-.5c-.1 0-.3 0-.3.2l-.2.6zm-.1-1.6c.1.1.3.1.4-.1l1-1.3c.1-.1.1-.3-.1-.3l-.5-.4c-.1-.1-.3-.1-.4.1l-1 1.3c-.1.1-.1.3.1.3l.5.4zm-1.4-.3c.1-.1.1-.2.1-.3l-.9-1.3c-.1-.1-.2-.1-.3-.1l-.5.4c-.1.1-.1.2-.1.3l.9 1.3c.1.1.2.1.3.1l.5-.4zm-.8 1.2c0-.1-.2-.2-.3-.2l-1.5.5c-.1 0-.2.2-.2.3l.2.6c0 .1.2.2.3.2l1.5-.5c.1 0 .2-.2.2-.3l-.2-.6z"
        className="icon-truck-st4"
      />
    </symbol>
  </Fragment>
);
export const iconTruck = (
  <svg aria-hidden key="iconTruck" xmlns="http://www.w3.org/2000/svg" width={71} height={27} className="mt-0_5 mb-0_5">
    <use xlinkHref="#icon-truck" />
  </svg>
);

export const iconHatchbackSymbol = (
  <Fragment key="iconHatchbackSymbol">
    <defs>
      <linearGradient
        id="linear-grad-hatch"
        x1={38.945}
        x2={39.186}
        y1={20.349}
        y2={14.688}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#4e91f5' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </linearGradient>
      <linearGradient
        id="linear-grad-hatch-2"
        x1={59.963}
        x2={59.963}
        y1={19.953}
        y2={15.665}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#4e91f5' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </linearGradient>
      <linearGradient
        id="linear-grad-hatch-3"
        x1={40.676}
        x2={40.676}
        y1={20.961}
        y2={15.202}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#046fc6' }} />
        <stop offset=".516" style={{ stopColor: '#00559b' }} />
        <stop offset={1} style={{ stopColor: '#002442' }} />
      </linearGradient>
      <linearGradient
        id="linear-grad-hatch-4"
        x1={50.48}
        x2={50.48}
        y1={21.288}
        y2={15.529}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#046fc6' }} />
        <stop offset=".516" style={{ stopColor: '#00559b' }} />
        <stop offset={1} style={{ stopColor: '#002442' }} />
      </linearGradient>
      <radialGradient
        id="linear-grad-hatch-5"
        cx={117.892}
        cy={419.623}
        r={1}
        gradientTransform="matrix(0 .9848 28.0575 0 -11737.725 -90.27)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#091a33' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </radialGradient>
    </defs>
    <symbol id="icon-hatchback" viewBox="0 0 71 27">
      <style dangerouslySetInnerHTML={{ __html: '.icon-hatch-st2{fill:#cce0ff}.icon-hatch-st9{fill:#033e96}' }} />
      <path
        d="M22.5 12.9C28 9 32.1 7.7 34 7.1c2-.5 10.3-1.7 25.4.3 0 0-.9.9-.6 1.2 1.6 1.6 1.9 2.1 3.2 3.6.5.6.8.9 1 1.6.3 1 0 2.3 0 2.8 0 .4 1.2.9 1.4 1.4 0 0 .1 1.9-.3 3 0 0-1 1.3-1.8 2-1 .3-4.3.5-4.3.5h-8.1c-2.3-.2-29.5.5-29.5.5l-7.7.2-4.7-.3-.2-.3-.8-.4.3-1.7v-1l-.1-.1V19l1-.9s.2-.6.4-1c.3-.5.6-.8.6-.8 3-2 9.4-3.1 13.3-3.4z"
        style={{ fill: '#fff', stroke: '#007ee5', strokeWidth: '.25' }}
      />
      <path
        d="M12.7 22.3c.2-3.4 2.6-5.4 5.4-5.2 2.8.2 5 2.7 4.8 6.1-.1 2.3 0 .7-6.1 1.4-3.5-.2-4.3 1.1-4.1-2.3zm37.4-.2c.2-3.4 2.6-5.4 5.4-5.2 2.8.2 5 2.1 4.8 6.1 0 .7.2.1-5.9.9-3.6-.2-4.5 1.6-4.3-1.8z"
        style={{ fill: '#0b406c' }}
      />
      <path
        d="M23.9 13.5c-8 0-14.9 3.3-15.2 3.3-.3 0 1.8-2.1 7.1-3.1s6.6-.8 6.6-.8 5.8-4.6 13-6.3 23.7.6 23.7.6l-.3 1.1s2.2 2.7 3.3 4.1c.6.8 1.4 1.1.8 3.9.3 1.1 1.4 1.7 1.4 1.7l-3.8 1.7-2.2-2.5.3-.6s2.4-2.5 2.4-3.4c0-.8-2.4-4.4-3.3-4.9-.7-.6-17.3-1.9-22.5-.9-5.2 1.1-9.9 5-11.3 6.1zm-1.7 3.3-.8.5 1.8 5.7 26.2-1.1 4-5.5c-.9-1-2.2-1.6-3.6-1.6-2.5.1-6.6.2-9.6.3-4.9.2-11.8.6-14.9.8-1.1.1-2.1.4-3.1.9z"
        className="icon-hatch-st2"
      />
      <path
        d="m52.8 8 1.7 3.1c.2.4-.1 1-.5 1 0 0-2.3 0-3.8.1-6.2.1-9.7.3-15.9.8-10.3.8-10.8.9-10.1.2 1.6-1.5 2.6-1.9 4.7-3.1 2.2-1.2 4.3-2 6.1-2.5 1.8-.4 11.3-1 17.6.1 0 0 .1.1.2.3z"
        style={{ fill: 'url(#linear-grad-hatch)' }}
      />
      <path
        d="m57.9 8.4 1-.7-.2.7 3.3 3.7h-1.3c-1-1.5-1.7-2.3-2.8-3.7z"
        style={{
          fill: 'url(#linear-grad-hatch-2)',
        }}
      />
      <path
        d="M42.3 7.1h-1.7l-1.5 5.4 2.6-.1.6-5.3z"
        style={{
          fill: 'url(#linear-grad-hatch-3)',
        }}
      />
      <path
        d="M50.9 7.5h-.4l-.5 4.6h.4l.5-4.6z"
        style={{
          fill: 'url(#linear-grad-hatch-4)',
        }}
      />
      <ellipse
        cx={35.9}
        cy={25.8}
        rx={28.1}
        ry={1}
        style={{
          fill: 'url(#linear-grad-hatch-5)',
        }}
      />
      <path
        d="M22.5 12.9C28 9 32.1 7.7 34 7.1c2-.5 10.3-1.7 25.4.3 0 0-.9.9-.6 1.2 1.6 1.6 1.9 2.1 3.2 3.6.5.6.8.9 1 1.6.3 1 0 2.3 0 2.8 0 .4 1.2.9 1.4 1.4 0 0 .1 1.9-.3 3 0 0-1 1.3-1.8 2-1 .3-4.3.5-4.3.5h-8.1c-2.3-.2-29.5.5-29.5.5l-7.7.2-4.7-.3-.2-.3-.8-.4.3-1.7v-1l-.1-.1V19l1-.9s.2-.6.4-1c.3-.5.6-.8.6-.8 2.2-1.7 9.1-3.1 13.3-3.4z"
        style={{ fill: 'none', stroke: '#007ee5', strokeWidth: '.25' }}
      />
      <path
        d="m7.9 19.2-.7-.2-.2 4.1 1.1.8 4.4.3 8.7-.3 27.7-.6h9.7l3.9-.5 1.6-2 .4-3-2.4.4-.8 1.1-11.6 2-26.4.8L12.6 20l-2.1.3.9-.9-1 .1-1.4-.1-1.1-.2z"
        className="icon-hatch-st9"
      />
      <path
        d="M49.4 21.4c.2-3.4 3.2-5.5 6.2-5.4 3 .2 5.7 2.2 5.4 6.3 0 .7-.2 0-6.7.7-3.6-.2-5.1 1.8-4.9-1.6zm-37.4.3c.2-3.4 3.2-5.5 6.2-5.4 3 .2 5.7 2.2 5.4 6.3-.1 2.5-.2 1.2-7 1.4-3.7-.2-4.8 1.1-4.6-2.3z"
        className="icon-hatch-st9"
      />
      <path
        d="M55.1 26.2c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1 4.1 1.8 4.1 4.1-1.9 4.1-4.1 4.1zm-37.2-.1c-2.3 0-4.1-1.9-4.1-4.1s1.9-4.1 4.1-4.1S22 19.7 22 22s-1.8 4.1-4.1 4.1z"
        style={{ fill: '#f0f6ff', stroke: '#091a33', strokeWidth: '.75' }}
      />
      <path
        d="M55.1 25.2c-1.7 0-3.1-1.4-3.1-3.1s1.4-3.1 3.1-3.1c1.7 0 3.1 1.4 3.1 3.1s-1.4 3.1-3.1 3.1zm-37.2-.1c-1.7 0-3.1-1.4-3.1-3.1s1.4-3.1 3.1-3.1c1.7 0 3.1 1.4 3.1 3.1s-1.4 3.1-3.1 3.1z"
        className="icon-hatch-st9"
      />
      <path
        d="m55.1 23 .2 2.2c0 .2-.1.3-.3.3l-1.7-.5 1.2-.5.3-.3.3-1.2zm-.8-.6-2.1.9c-.2.1-.3 0-.3-.2v-1.7l.9.9c.1.1.2.2.4.2l1.1-.1zm.2-1L53 19.8c-.1-.1-.1-.3.1-.4l1.6-.6-.7 1.1c-.1.1-.1.3 0 .4l.5 1.1zm1.1 0 1.1-1.9c.1-.1.3-.2.4 0l1.1 1.4-1.3-.3c-.1 0-.3 0-.4.1l-.9.7zm.3.9 2.2.5c.2 0 .3.2.1.4l-1 1.4-.1-1.3c0-.1-.1-.3-.2-.4l-1-.6zm-38 .6.2 2.2c0 .2-.1.3-.3.3l-1.7-.5 1.2-.5.3-.3.3-1.2zm-.8-.6-2.1.9c-.2.1-.3 0-.3-.2v-1.7l.9 1c.1.1.2.2.4.2l1.1-.2zm.2-1-1.5-1.7c-.1-.1-.1-.3.1-.4l1.7-.6-.7 1.1c-.1.1-.1.3 0 .4l.4 1.2zm1.1 0 1.2-1.9c.1-.1.3-.2.4 0l1.1 1.4-1.3-.3c-.1 0-.3 0-.4.1l-1 .7zm.4.9 2.2.5c.2 0 .3.2.1.4l-1 1.4-.1-1.3c0-.1-.1-.3-.2-.4l-1-.6z"
        className="icon-hatch-st2"
      />
      <path
        d="M23.9 13.3c-.9 2.2-.6 6.2.5 9.6M41.5 7.1l-1 4.7c-1.1 3-1.3 6.7-1.3 11.4"
        style={{ fill: 'none', stroke: '#003159', strokeWidth: '.1' }}
      />
    </symbol>
  </Fragment>
);
export const iconHatchback = (
  <svg
    aria-hidden
    key="iconHatchback"
    xmlns="http://www.w3.org/2000/svg"
    width={71}
    height={27}
    className="mt-0_5 mb-0_5"
  >
    <use xlinkHref="#icon-hatchback" />
  </svg>
);

export const iconWagonSymbol = (
  <Fragment key="iconWagonSymbol">
    <defs>
      <linearGradient
        id="linear-gradient-wagon"
        x1={41.41}
        x2={41.41}
        y1={20.511}
        y2={15.146}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#7aafff' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </linearGradient>
      <linearGradient
        id="linear-gradient-wagon-2"
        x1={39.441}
        x2={39.441}
        y1={20.701}
        y2={14.899}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#046fc6' }} />
        <stop offset=".516" style={{ stopColor: '#004177' }} />
        <stop offset={1} style={{ stopColor: '#002442' }} />
      </linearGradient>
      <linearGradient
        id="linear-gradient-wagon-3"
        x1={50.06}
        x2={50.06}
        y1={20.657}
        y2={14.854}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#046fc6' }} />
        <stop offset=".516" style={{ stopColor: '#003e71' }} />
        <stop offset={1} style={{ stopColor: '#002442' }} />
      </linearGradient>
      <linearGradient
        id="linear-gradient-wagon-4"
        x1={15.132}
        x2={15.395}
        y1={4.884}
        y2={13.309}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#cce0ff' }} />
        <stop offset={1} style={{ stopColor: '#2070e8' }} />
      </linearGradient>
      <linearGradient
        id="linear-gradient-wagon-5"
        x1={52.968}
        x2={53.231}
        y1={4.884}
        y2={13.309}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#cce0ff' }} />
        <stop offset={1} style={{ stopColor: '#2070e8' }} />
      </linearGradient>
      <radialGradient
        id="linear-gradient-wagon-6"
        cx={102.037}
        cy={418.691}
        r={1}
        gradientTransform="matrix(0 1.0268 31.0656 0 -12971.557 -80.446)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#091a33' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </radialGradient>
    </defs>
    <symbol id="icon-wagon" viewBox="0 0 71 27">
      <style
        dangerouslySetInnerHTML={{
          __html: '.icon-wagon-st7{fill:#cce0ff}.icon-wagon-st17{fill:#091a33}',
        }}
      />
      <path
        d="M35.5 6.4c-.6.1-1.1.4-1.3.6.5.3 1.5.8 1.9.8.5 0 1.2.1 1.7 0 .4-.1 5.5.6 9 .6s3-.4 3.6-.4c.5 0 3 .3 4.1.4l.7-.9-.4-.5-1-.4c-1.1-.1-4.5-.4-9.1-.6-5.7-.2-8.5.3-9.2.4z"
        style={{ fill: '#013c6d' }}
      />
      <path
        d="m5.2 15.9-.9 5.2.4.7-.7.5 2.2.5 3 .2H23.8l.5-.2 19.7-.2.2.2 13.8-.6 4.1-.8.2.2 2.8-.5.3-.5h.6v-3.2l-1.2-.7v-.8l-.2-1.5.5-.5v-.6l-.5-.7-.2-.9L58 8.4l-.2-.4.7-.6s-6-.8-12.7-1c-5.5-.2-11.8.1-14 .7-4.9 1.6-6.8 2.9-10.6 5-6.8 1.2-12.2.8-16 3.8z"
        style={{ fill: '#c0e3ff', stroke: '#000', strokeWidth: '.1' }}
      />
      <path
        d="m5.2 15.9-.9 5.2.4.7-.7.5 2.2.5 3 .2H23.8l.5-.2 19.7-.2.2.2 13.8-.6 4.1-.8.2.2 2.8-.5.3-.5h.6v-3.2l-1.2-.7v-.8l-.2-1.5.5-.5v-.6l-.5-.7-.2-.9L58 8.4l-.2-.4.7-.6s-6-.8-12.7-1c-5.5-.2-11.8.1-14 .7-4.9 1.6-6.8 2.9-10.6 5-6.8 1.2-12.2.8-16 3.8z"
        style={{ fill: '#a3c8ff', stroke: '#007ee5', strokeWidth: '.1' }}
      />
      <path
        d="M66.1 17.4v3.2h-.6l-.3.5-2.8.5-.2-.2-4.2.8-13.8.5-.2-.1-19.7.2-.5.2H9.2l-3-.2-2.1-.7"
        style={{ fill: 'none', stroke: '#091a33', strokeWidth: '.75' }}
      />
      <path d="M66.1 20.6V18.3l-1.2.2-2.7 2.9.2.2 2.8-.5.3-.5h.6z" style={{ fill: '#033e96' }} />
      <path
        d="m64.6 14.4.2 1.5v.8l1.2.7v.9l-1.2.2-2.7 2.9-4.5.9v-3.8l8.4-1.1-1.2-.7-4.6.5-.6-.3 2.9-2.3 2.1-.2z"
        style={{ opacity: '.5', fill: '#1358bf', enableBackground: 'new' }}
      />
      <path
        d="M21.2 12.1c-6.9 1.2-12.2.8-16 3.8l-.3 1.7 1.7-.2.5 1.6h9.1l3.7-1.4.4-1.1c.3-.7.9-1.2 1.7-1.3 8.2-.7 13.5-1 21.5-.9 1.2 0 2.5.2 3.6.6l2.9 1h5.1l1.3-.8c.8-.5 1.8-.8 2.8-.8h5.3l.5-.5v-.6l-.5-.7-.2-.9L58 8.4l-.2-.4.7-.6s-6-.8-12.7-1c-5.5-.2-11.8.1-14 .7-4.9 1.6-6.8 2.9-10.6 5zm24.6 8.1-23.7.7s3-.5 5-.7c4-.3 12.1-.7 15.1-.6 1.4.1 3.6.6 3.6.6zm-22.1 2.4H21l.4-.3c.5-.4 1.2-.6 1.9-.6 2.1-.1 6.8-.3 10.1-.4 3.8-.1 9.5-.2 11.1-.2.3 0 .5.1.7.2l1.9 1h-2.8c-.2 0-.3 0-.5-.1s-.6-.2-.9-.2c-.5-.1-1.3-.1-1.3-.1s-5.3.1-8.5.1c-2.6.1-6.1.2-7.4.2-.3 0-.6.1-.9.1l-.4.1c-.3.1-.5.2-.7.2z"
        style={{ fill: '#fff' }}
      />
      <path
        d="M21.2 12.1c-6.9 1.2-12.2.8-16 3.8L9 15c2.7-1.6 8.4-1.9 14.2-2.1 0 0 12.4-.7 20.5-.9 10.1-.3 20.8-.2 20.8-.2L58 8.4l-.2-.4.7-.6s-6-.8-12.7-1c-5.5-.2-11.8.1-14 .7-4.9 1.6-6.8 2.9-10.6 5z"
        className="icon-wagon-st7"
      />
      <path
        d="M64.4 12.6h-3.3c-.2 0-.3.3-.2.4l1.5 1.6c.1.1.2.2.4.2h.4c.1 0 .2 0 .2-.1.1-.2.3-.2.4-.2h.7l.8-.7-.6-.9c0-.1-.1-.1-.2-.1h-.1zm-6.6-4.5.7-.6-2.2.8 6 3h1.2L58 8.4l-.2-.3zM7.9 15.3l-2 .5c-.1 0-.2.2-.2.3l.2.5c.1.2.3.3.5.3l1.5-.2c.3 0 .6-.2.9-.3l1.6-1.1c.1-.1.1-.3-.1-.3l-1.2.1c-.4 0-.8 0-1.2.2z"
        style={{ fill: '#1358bf' }}
      />
      <path
        d="m6.4 17.5-1 .1c-.2 0-.3.1-.3.3l-.6 3.2s.5.6.8.8c.4.3 1.1.6 1.1.6h2.9l-.6-.3h-2l.6-1.5c.1-.2.1-.4 0-.6l-.5-2.4c0-.1-.2-.2-.4-.2z"
        style={{ fill: '#1561d4' }}
      />
      <path d="m25.1 22.3-.8.5 19.9-.2-1-.7-18.1.4z" style={{ fill: '#005ca8' }} />
      <path
        d="M32.3 7.8c-3.8 1-9 4.8-9 4.8 11.3-.7 19.1-1 36.2-1 0 0-4.4-3-7.3-3.6-3.1-.6-14.5-1.7-19.9-.2z"
        style={{ fill: 'url(#linear-gradient-wagon)' }}
      />
      <path
        d="M58.3 11.2c-15.6 0-23.3.3-33.6.9.5-.3 1.2-.8 1.9-1.2 1.8-1.1 4-2.3 5.8-2.8 2.6-.7 6.8-.8 10.7-.6 3.9.2 7.5.6 9.1.9 1.4.3 3.1 1.1 4.6 2 .5.2 1 .5 1.5.8z"
        style={{ fill: 'none', stroke: '#033e96', strokeWidth: '.75' }}
      />
      <path
        d="M41.1 7.4s-1-.1-1.8 0l-1.4 4.4h2.4l.8-4.4z"
        style={{
          fill: 'url(#linear-gradient-wagon-2)',
        }}
      />
      <path
        d="M49.3 7.6h-.7l1.1 2.2-.3 1.8h2.1l-2.2-4z"
        style={{
          fill: 'url(#linear-gradient-wagon-3)',
        }}
      />
      <path
        d="M9.6 22.8c-1.2-5.8 2.7-8.2 5.6-8.1 2.9.1 6.4 2.3 5.6 8.3 0 .3-1.2-.8-5.7 0-5.6-.7-5.4.3-5.5-.2z"
        style={{
          fill: 'url(#linear-gradient-wagon-4)',
        }}
      />
      <path
        d="M47.5 22.8c-1.2-5.8 2.7-8.2 5.6-8.1 2.9.1 6.4 2.3 5.6 8.3 0 .3-1.2-.8-5.7 0-5.7-.7-5.4.3-5.5-.2z"
        style={{
          fill: 'url(#linear-gradient-wagon-5)',
        }}
      />
      <path
        d="M7.3 20.2 6.8 18c-.7.8-1 1.5-1.4 2.7 0 .1 0 .3.1.4l1.3.8.4-1.1c.2-.2.2-.4.1-.6zm2.8 2.7c-.9-5.6 2.5-7.7 5.1-7.6 2.6.1 5.8 1.9 5.1 7.3 0 .2-.9-.2-4.8.5-4.6-.2-5.3.2-5.4-.2zm37.8 0c-.9-5.6 2.5-7.7 5.1-7.6 2.6.1 5.8 1.9 5.1 7.3 0 .2-.9-.2-4.8.5-4.5-.2-5.3.2-5.4-.2z"
        className="icon-wagon-st17"
      />
      <path
        d="M66.4 24.6c0 .7-13.9.8-31.1.8-17.2 0-31.1-.1-31.1-.8s13.9-1.3 31.1-1.3c17.2 0 31.1.6 31.1 1.3z"
        style={{
          fill: 'url(#linear-gradient-wagon-6)',
        }}
      />
      <path
        d="M49.8 24.8c-1.5-.9-1.8-1.1-2.3-2.2H49l2.6 2.2h-1.8zm-31.4 0c1.5-.9 1.8-1.1 2.3-2.2h-1.5l-2.6 2.2h1.8z"
        style={{ fill: '#003159' }}
      />
      <path
        d="M52.9 24.6c-2.4 0-4.3-1.9-4.3-4.3s1.9-4.3 4.3-4.3 4.3 1.9 4.3 4.3-1.9 4.3-4.3 4.3zm-37.7 0c2.4 0 4.3-1.9 4.3-4.3S17.6 16 15.2 16s-4.3 1.9-4.3 4.3 1.9 4.3 4.3 4.3z"
        style={{ fill: '#f0f6ff', stroke: '#033e96', strokeWidth: '.75' }}
      />
      <path
        d="M52.6 23.3c-1.8 0-3.3-1.4-3.3-3.2 0-1.8 1.5-3.2 3.3-3.2 1.8 0 3.3 1.4 3.3 3.2 0 1.7-1.5 3.2-3.3 3.2zm-37.5 0c1.8 0 3.3-1.4 3.3-3.2 0-1.8-1.5-3.2-3.3-3.2s-3.3 1.4-3.3 3.2c.1 1.7 1.5 3.2 3.3 3.2z"
        className="icon-wagon-st17"
      />
      <path
        d="m52.7 21 .2 2.2c0 .2-.1.3-.3.3l-1.8-.5 1.3-.5.3-.3.3-1.2zm-.9-.6-2.2.9c-.2.1-.3-.1-.3-.2v-1.8l.9 1c.1.1.2.2.4.2l1.2-.1zm.2-1-1.5-1.7c-.1-.1-.1-.3.1-.4l1.7-.6-.7 1.1c-.1.1-.1.3 0 .4l.4 1.2zm1.1-.1 1.2-1.9c.1-.1.3-.2.4 0l1.1 1.4-1.4-.3c-.1 0-.3 0-.4.1l-.9.7zm.4 1 2.3.5c.2 0 .3.2.1.4l-1 1.4-.1-1.3c0-.2-.1-.3-.2-.4l-1.1-.6zm-38.4.7-.2 2.2c0 .2.1.3.3.3L17 23l-1.3-.5-.3-.3-.3-1.2zm.9-.6 2.2.9c.2.1.3-.1.3-.2v-1.8l-.9 1c-.1.1-.2.2-.4.2l-1.2-.1zm-.3-1 1.5-1.7c.1-.1.1-.3-.1-.4l-1.7-.6.7 1.1c.1.1.1.3 0 .4l-.4 1.2zm-1.1-.1-1.2-1.9c-.1-.1-.3-.2-.4 0l-1.1 1.4 1.4-.3c.1 0 .3 0 .4.1l.9.7zm-.4 1-2.3.5c-.2 0-.3.2-.1.4l1 1.4.1-1.3c0-.2.1-.3.2-.4l1.1-.6z"
        className="icon-wagon-st7"
      />
      <path
        d="m40.2 7.3-1.3 4.5c-1 2.9-1.4 5.8-1.4 10.3m13-10.6c.1.2.2.6.3.8 0 .2 0 .5-.1.7-2.1 3.4-3.6 6-4.3 7.1-.3.4-.7.7-1.2.7-1.9.1-6.7.4-11.8.5-6.4.1-13.4.2-13.4.2m3.4-8.9c-1.4 2.1-.9 5.6-.6 9"
        style={{ fill: 'none', stroke: '#003159', strokeWidth: '.1' }}
      />
    </symbol>
  </Fragment>
);
export const iconWagon = (
  <svg aria-hidden key="iconWagon" xmlns="http://www.w3.org/2000/svg" width={71} height={27} className="mt-0_5 mb-0_5">
    <use xlinkHref="#icon-wagon" />
  </svg>
);

export const iconMinivanSymbol = (
  <Fragment key="iconMinivanSymbol">
    <defs>
      <radialGradient
        id="radial-grad-minivan"
        cx={-105.379}
        cy={418.202}
        r={1}
        gradientTransform="matrix(0 2.3205 32.9191 0 -13730.913 269.4)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#091a33' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </radialGradient>
      <linearGradient
        id="radial-grad-minivan-2"
        x1={65.085}
        x2={65.085}
        y1={22.638}
        y2={16.657}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#7aafff' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </linearGradient>
      <linearGradient
        id="radial-grad-minivan-3"
        x1={22.138}
        x2={22.138}
        y1={21.962}
        y2={16.416}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#012a4c' }} />
        <stop offset={1} style={{ stopColor: '#003866', stopOpacity: '.85' }} />
      </linearGradient>
      <linearGradient
        id="radial-grad-minivan-4"
        x1={42.74}
        x2={42.74}
        y1={13.68}
        y2={4.361}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#cce0ff' }} />
        <stop offset={1} style={{ stopColor: '#1358bf' }} />
      </linearGradient>
      <linearGradient
        id="radial-grad-minivan-5"
        x1={14.93}
        x2={15.2}
        y1={4.07}
        y2={12.747}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#a3c8ff' }} />
        <stop offset={1} style={{ stopColor: '#2070e8' }} />
      </linearGradient>
      <linearGradient
        id="radial-grad-minivan-6"
        x1={54.435}
        x2={54.706}
        y1={4.069}
        y2={12.746}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#a3c8ff' }} />
        <stop offset={1} style={{ stopColor: '#2070e8' }} />
      </linearGradient>
      <linearGradient
        id="radial-grad-minivan-7"
        x1={42.47}
        x2={42.47}
        y1={22.254}
        y2={14.835}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#7aafff' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </linearGradient>
      <linearGradient
        id="radial-grad-minivan-8"
        x1={35.933}
        x2={35.933}
        y1={22.73}
        y2={17}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#046fc6' }} />
        <stop offset=".516" style={{ stopColor: '#00559b' }} />
        <stop offset={1} style={{ stopColor: '#002442' }} />
      </linearGradient>
      <linearGradient
        id="radial-grad-minivan-9"
        x1={50.128}
        x2={50.128}
        y1={22.692}
        y2={16.935}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#046fc6' }} />
        <stop offset=".516" style={{ stopColor: '#00559b' }} />
        <stop offset={1} style={{ stopColor: '#002442' }} />
      </linearGradient>
    </defs>
    <symbol id="icon-minivan" viewBox="0 0 71 27">
      <style
        dangerouslySetInnerHTML={{
          __html: '.icon-mini-st4{fill:#033e96}.icon-mini-st10{fill:#091a33}',
        }}
      />
      <path
        d="M68.8 25.5c0 1.6-14.7 1.7-32.9 1.7S3 27.1 3 25.5s14.7-2.9 32.9-2.9 32.9 1.3 32.9 2.9z"
        style={{ fill: 'url(#radial-grad-minivan)' }}
      />
      <path
        d="M5.5 14.3c-1.1.8-2.2 4.2-2.2 4.2l-.2 2 .4.3v.8l-.4.6 3.6 1.4 13 .2 29-.3 11.7-.5 8.2-1.4.6-2.8-.6-.3-.2-.9s.3-4.7 0-5.7S64.2 6 64.2 6l.3-.8S56.8 4 46.8 4c-7.4 0-15.5.1-19.6 1.5-4.5 1.5-10.9 5.6-10.9 5.6s-3.4.5-5.4 1.1c-2.2.6-4.5 1.5-5.4 2.1z"
        style={{ fill: '#fff', stroke: '#007ee5', strokeWidth: '.125' }}
      />
      <path
        d="M13.6 16.2c-3 .9-9.6 1.6-9.9 1.6l.1 3.6-.5.8 4.3 1.3 52.7-.7 8.2-1.3.6-2.8-.6-.3-.3-1.1.1-3.7-.1-2.1-1 .2-15 .4 3.8 1.4c-4.6-.7-8.1-1.2-10.8-1.4-4.1-.1-17 .9-26.5 1.7h-.1l-5 2.4z"
        style={{ fill: '#cce0ff' }}
      />
      <path
        d="M66.9 15c.3-.4 0-2.4-.5-3.9l1.4-.2.4.8c.2 2.2.1 3.5 0 5.8l.3.9.6.3-.6 2.8-1.7.3.5-2.6s-.6-.3-.8-.6c-.3-.6-.5-2.9-.5-2.9s.6-.3.9-.7z"
        style={{ fill: '#a3c8ff' }}
      />
      <path
        d="M16.9 11.2c-3.6 1.3-7.1 1.4-11.6 3.2 3.5-.6 5.3-.8 8.3-1.1.8-.1 1.3-.1 1.3-.1-.5 0-.9.1-1.3.1-1.8.2-4.9.8-6.1 2.6-.9 1.3-1.5 1.9-1.6 3.4-.1 1.1.4 1.4.4 2.9 0 .2 1.3 1.2 1.3 1.2h-.9l-3.6-1.3.4-.5v-.9l-.4-.3.2-2c.5-1.5.8-2.9 2-4.1 0 0 .6-.8 5.1-2.1 2.6-.8 6-1.3 6-1.3S22.5 6.8 27 5.5h.1c2.8-.8 3.8-1.1 7.5-1.3 4-.2 5.7-.3 11.1-.3 4 0 6.3 0 10.3.3 3.3.2 8.4.9 8.4.9l-.3.9s-4.6-.5-7.4-.7c-10.6-.8-14.1-.9-21.5-.4-3.4.2-4.9.3-8.1 1.4-1.7.5-7.3 3.9-10.2 4.9z"
        className="icon-mini-st4"
      />
      <path
        d="m66.4 11-4-5.2v-.9l2.2.3-.4.8c1.4 1.9 2.7 3.5 3.5 4.9l-1.3.1z"
        style={{
          fill: 'url(#radial-grad-minivan-2)',
        }}
      />
      <path
        d="M18.2 10.8c-1 .4-2 .5-2.1.5 3.3-2 5.6-3.8 11-5.7l1 .2s-2.2.9-4.5 2c-3.1 1.6-4.9 2.8-5.4 3z"
        style={{
          fill: 'url(#radial-grad-minivan-3)',
        }}
      />
      <path
        d="M28.6 19.8c-5.2-1.7-6.3-2.6-9.8-4.5l-2.4 1.3 3.7 7.1 39.1-.7 9.2-1.5.7-2.8-.6-.3-.3-1.1.2-3h-.7s-.8 1.3-1.7 1.5c-2.4.6-35 4.7-37.4 4z"
        style={{
          fill: 'url(#radial-grad-minivan-4)',
        }}
      />
      <path
        d="M8.3 23.6c-.9-5.6 3.2-8.4 6.7-8.3 3.5.1 7 2.4 6.8 8.6 0 .3-1.5-.9-6.8 0-6.9-.8-6.7.2-6.7-.3z"
        style={{
          fill: 'url(#radial-grad-minivan-5)',
        }}
      />
      <path
        d="M59.5 20.7 3.1 22.2l3.7 1.4 12.5.2 29.5-.3 10.3-.6 1.2-.1 8.2-1.4.6-2.6-8.4 1.2-1.2.7z"
        className="icon-mini-st4"
      />
      <path
        d="M47.8 23.6c-.5-5.8 3.2-8.4 6.7-8.3 3.5.1 6.8 2 6.8 7.5 0 .3-1.4.2-6.8 1.1-7-.8-6.7-.3-6.7-.3z"
        style={{
          fill: 'url(#radial-grad-minivan-6)',
        }}
      />
      <path
        d="M9.1 23.7C8.5 18 12 16.1 15 16.2c3 .1 6.2 1.8 5.8 7.5 0 .2-1-.3-5.5.5-5.9-.7-6.1 0-6.2-.5zm39.7-.4c-.6-5.7 2.9-7.3 5.9-7.2 3 .1 6 1.9 5.6 6.7 0 .2-1.1-.2-5.3 1.3-3.9 1.8-6.2-.3-6.2-.8z"
        className="icon-mini-st10"
      />
      <path
        d="M5.5 14.3c-1.1.8-2.2 4.2-2.2 4.2l-.2 2 .4.3v.8l-.4.6 3.6 1.4 13 .2 29-.3 11.7-.5 8.2-1.4.6-2.8-.6-.3-.2-.9s.3-4.7 0-5.7S64.2 6 64.2 6l.3-.8S56.8 4 46.8 4c-7.4 0-15.5.1-19.6 1.5-4.5 1.5-10.9 5.6-10.9 5.6s-3.4.5-5.4 1.1c-2.2.6-4.5 1.5-5.4 2.1z"
        style={{ fill: 'none', stroke: '#007ee5', strokeWidth: '.125' }}
      />
      <path
        d="M18.6 11.8s-.1.1-.1.2c.1.3.4.6.7.7.2.1.4.1.4.1s14.6-1.5 23.6-1.7c1.1 0 2.4-.1 3.3.1 1.9.2 3.1.4 4.5.4 6.2-.1 15.4-.5 15.4-.5l-1.1-1.5h-1.2s-.9-.2-1.4-.5c-1.1-.7-2.1-1.3-3.6-2.1-1.7-.9-2.6-1.2-4.4-1.3-8.6-.7-13.9-.7-20.1-.3-3 .2-4 .5-6.5 1.2-4 1.3-9.5 5.2-9.5 5.2z"
        style={{
          fill: 'url(#radial-grad-minivan-7)',
        }}
      />
      <path
        d="M37.6 5.3c-.6 0-1.5 0-2.4.1l-.9 6.1 3-.2.3-6z"
        style={{
          fill: 'url(#radial-grad-minivan-8)',
        }}
      />
      <path
        d="M50.4 5.4c-.5 0-1-.1-1.5-.1l-.3 6.1 1.3.1h1.8l-1.3-6.1z"
        style={{
          fill: 'url(#radial-grad-minivan-9)',
        }}
      />
      <path
        d="m36.8 4.3-.3 1-.7 6.2-.1 1.2c-.4 3.3-.3 6.1 0 10.8M21 12.6c-.3 3.7.4 6.5 1.1 10.9m29.5-11.9c-.1 2.1-.7 4.5-1.6 6.4"
        style={{ fill: 'none', stroke: '#00457d', strokeWidth: '7.500000e-02' }}
      />
      <path
        d="M15 26.5c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5zm39.4-.1c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5z"
        style={{ fill: '#d6edff', stroke: '#033e96', strokeWidth: '.75' }}
      />
      <path
        d="M15 25.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm39.4-.1c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.5 3.5-3.5 3.5z"
        className="icon-mini-st10"
      />
      <path
        d="M15 23.1v2.3m-1.2-3.1-2.2.7m2.7-2.1L12.9 19m2.8 1.9 1.4-1.9m-1 3.3 2.2.7"
        style={{
          fill: 'none',
          stroke: '#cce0ff',
          strokeWidth: '.375',
          strokeLinecap: 'round',
        }}
      />
      <path
        d="M54.3 23v2.3m-1.1-3.1-2.2.7m2.6-2.1-1.4-1.9m2.9 1.9 1.4-1.9m-1 3.3 2.2.7"
        style={{
          fill: 'none',
          stroke: '#d6edff',
          strokeWidth: '.375',
          strokeLinecap: 'round',
        }}
      />
      <path d="m3.5 17.9 2.9-.3c.6-.8.8-1.4 1.4-1.8 0 0-2.6.5-3 .8-.4.2-1.3 1.3-1.3 1.3z" style={{ fill: '#c6e6ff' }} />
    </symbol>
  </Fragment>
);
export const iconMinivan = (
  <svg
    aria-hidden
    key="iconMinivan"
    xmlns="http://www.w3.org/2000/svg"
    width={71}
    height={27}
    className="mt-0_5 mb-0_5"
  >
    <use xlinkHref="#icon-minivan" />
  </svg>
);

export const iconCoupeSymbol = (
  <Fragment key="iconCoupeSymbol">
    <defs>
      <radialGradient
        id="radial-grad-coupe"
        cx={158.258}
        cy={419.437}
        r={1}
        gradientTransform="matrix(0 .892 28.6096 0 -11964.326 -115.318)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#091a33' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </radialGradient>
      <linearGradient
        id="radial-grad-coupe-2"
        x1={31.754}
        x2={31.754}
        y1={17.428}
        y2={13.505}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#7aafff' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </linearGradient>
      <linearGradient
        id="radial-grad-coupe-3"
        x1={42.29}
        x2={42.29}
        y1={16.828}
        y2={12.445}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#7aafff' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </linearGradient>
      <linearGradient
        id="radial-grad-coupe-4"
        x1={44.919}
        x2={44.919}
        y1={16.704}
        y2={13.747}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#046fc6' }} />
        <stop offset=".516" style={{ stopColor: '#00559b' }} />
        <stop offset={1} style={{ stopColor: '#002442' }} />
      </linearGradient>
    </defs>
    <symbol id="icon-coupe" viewBox="0 0 71 27">
      <style dangerouslySetInnerHTML={{ __html: '.icon-coupe-st11{fill:#091a33}' }} />
      <path d="M63.6 17.4s-1.4 0-2 .1l-.7 3.8c0-.1 1.8-2.6 2.7-3.9z" style={{ fill: '#0b406c' }} />
      <path
        d="M10.6 17c-1.4.7-3.1 2.1-3.1 2.1l-.5.5.5 3.5-.2.8 1.5.5 3.5.2h36l9.8-.2 4-1s1.2-2 1.5-3.5c.2-1.1.2-2.8.2-2.8s-.7-.7-1-1.2c-.2-.4-.2-1-.2-1l.2-.2-.2-.2c-1.9-.2-3-.4-5-.5 0 0-3.8-1.4-6.2-2-5.1-1.3-9.3-2.1-13.5-1.8-1.4.1-2.2.1-3.5.5-3.6 1.1-8.2 3.6-8.2 3.6s-4.8.2-10.6 1.2c-1.6.1-3.7.8-5 1.5z"
        style={{ fill: '#fff', stroke: '#007ee5', strokeWidth: '.25' }}
      />
      <path d="m33.5 22.8 12.7-4.3-2.8 4-9.9.3z" style={{ fill: '#033e96' }} />
      <path
        d="M15.1 15.5c-4.4.8-7.2 3.5-7.2 3.5s4.5-2.1 7.5-2.8c4.6-1 12.5-2.3 12.5-2.3s-8.6.8-12.8 1.6z"
        style={{ fill: '#c5e6ff' }}
      />
      <path
        d="M15.1 15.5c-4.4.8-7.2 3.5-7.2 3.5s4.2-2.4 7.3-3.1C19.8 14.9 28 14 28 14s-8.7.7-12.9 1.5z"
        style={{ fill: '#0064ae' }}
      />
      <ellipse cx={35.6} cy={25.8} rx={28.6} ry=".9" style={{ fill: 'url(#radial-grad-coupe)' }} />
      <path
        d="M28.6 13.7c-1.4.5-2.7.6-2.7.6s2.9-1.4 5-2.4c3.7-1.8 6.6-1.6 6.6-1.6s-2 .2-3.1.7c-2.1.9-3.8 2-5.8 2.7z"
        style={{
          fill: 'url(#radial-grad-coupe-2)',
        }}
      />
      <path
        d="M29.6 17.4 7.1 19.6l.4 3.4-.3.9 1.6.5 3.6.2 9.2-.4 4-.8 7.9-.3 11.2-3.3 1.9-1.1-6.5 4.7c-4.4.3-13.2.8-13.5.8-.3.1-.7.3-.8.4h22.5l9.9-.3 4-1.1.7-1.7-3.7.3 1.8-.6s1.2-3.5.9-5c-.3-1.2-6.2 1-6.2 1l-5.7.5-6.5-1.2-13.9.9zm-1.5-2.1-6.3 1.4 39.9-1.4-1.1-.5 2-.4-13.1-1.2-21.4 2.1z"
        style={{ fill: '#cce0ff' }}
      />
      <path
        d="M45 14.5c-3.8.2-17.3.8-17.3.8 3.4-2 6.7-4 9.1-4.4 4.6-.6 11.1.6 18 2.1l2.1.8s-6.9-.6-8.2-.5c-.4.1-2.2 1.1-3.7 1.2z"
        style={{
          fill: 'url(#radial-grad-coupe-3)',
        }}
      />
      <path
        d="m43.6 14.5.8-3.2 1.8.2-.5 2.9-2.1.1z"
        style={{
          fill: 'url(#radial-grad-coupe-4)',
        }}
      />
      <path
        d="M44.9 14.1c.5 1.3.5 2.8-.1 4.1-.1.3-.3.5-.4.8-1.3 2.3-3.7 3.6-6.4 3.8-3.5.2-7.4.4-10.5.5m-5.2.1s2.2-.1 5.2-.2m.4-8c-.3.2-.7.4-1.1.9 0 0-.3.8-.2 3.4.2 2.7.8 3.6.8 3.6"
        style={{ fill: 'none', stroke: '#003159', strokeWidth: '.1' }}
      />
      <path
        d="M12 22.1c.2-3.5 2.7-5.3 5.4-5.2 2.7.2 5.3 2.2 5.1 6.4-.1 1.9-1 1.1-5.1 1.8-5.2-.8-5.6.5-5.4-3zm36 0c.2-3.5 2.7-5.3 5.4-5.2 2.7.2 5.3 2.2 5.1 6.4-.1 1.9-1 1.1-5.1 1.8-5.2-.8-5.6.5-5.4-3z"
        className="icon-coupe-st11"
      />
      <path
        d="M17.1 26.1c-2.2 0-4-1.8-4-4.1s1.8-4.1 4-4.1 4 1.8 4 4.1c.1 2.3-1.8 4.1-4 4.1zm36.1 0c-2.2 0-4-1.8-4-4.1s1.8-4.1 4-4.1 4 1.8 4 4.1-1.8 4.1-4 4.1z"
        style={{ fill: '#fff', stroke: '#033e96', strokeWidth: '.75' }}
      />
      <path
        d="M17.1 25.2c-1.7 0-3.1-1.4-3.1-3.2 0-1.7 1.4-3.2 3.1-3.2 1.7 0 3.1 1.4 3.1 3.2 0 1.7-1.4 3.2-3.1 3.2zm36.1 0c-1.7 0-3.1-1.4-3.1-3.2 0-1.7 1.4-3.2 3.1-3.2 1.7 0 3.1 1.4 3.1 3.2-.1 1.7-1.4 3.2-3.1 3.2z"
        className="icon-coupe-st11"
      />
      <path
        d="M17.1 23v2.3m.9-2.8 1.8 1.4m-1.5-2.4 2.2-.5m-2.9-.3 1-2.1m-2 2.1-1-2.1m.4 2.9-2.2-.5m2.4 1.5L14.4 24m38.8-1v2.3m.9-2.8 1.8 1.4m-1.6-2.4 2.2-.5m-2.8-.3 1-2.1m-2 2.1-1-2.1m.3 2.9-2.1-.5m2.4 1.5L50.5 24"
        style={{ fill: 'none', stroke: '#fff', strokeWidth: '.5' }}
      />
    </symbol>
  </Fragment>
);
export const iconCoupe = (
  <svg aria-hidden key="iconCoupe" xmlns="http://www.w3.org/2000/svg" width={71} height={27} className="mt-0_5 mb-0_5">
    <use xlinkHref="#icon-coupe" />
  </svg>
);

export const iconSuvSymbol = (
  <Fragment key="iconSuvSymbol">
    <defs>
      <linearGradient
        id="linear-grad-suv"
        x1={43.063}
        x2={43.063}
        y1={24.815}
        y2={18.424}
        gradientTransform="matrix(1 0 0 -1 0 28)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#7aafff' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </linearGradient>
      <radialGradient
        id="linear-grad-suv-2"
        cx={121.58}
        cy={418.64}
        r={1}
        gradientTransform="matrix(0 .9755 31.25 0 -13047.25 -92.58)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} style={{ stopColor: '#091a33' }} />
        <stop offset={1} style={{ stopColor: '#033e96' }} />
      </radialGradient>
    </defs>
    <symbol id="icon-suv" viewBox="0 0 71 27">
      <style dangerouslySetInnerHTML={{ __html: '.icon-suv-st7{fill:#091a33}' }} />
      <path
        d="M6.8 11.2C4.3 15 4 17.3 4.9 20.8l-.9.7 5.4 1 10.1-.3h29l11-.3 6-1.6c.8-1.3 1.1-2.2 1.6-3.8l-.4-1.5c.1-2.2 0-3.5-.3-5.8l-1.6-.6L61 5.7l1.6-1.4s-4.8-.5-16.1-1.2-14.2.7-14.2.7l-4.4 2.4-5.4 3.3c-6.4.4-8.4.4-15.7 1.7z"
        style={{ fill: '#fff' }}
      />
      <path
        d="M50.2 18.5 4.6 19.9l.3.7-.8.8 5.6 1.1H48.1l10.3-.5 6.6-2.1 1.2-2.2.3-1.6-.3-1-5.6 1.6-10.4 1.8z"
        style={{ fill: '#a3c8ff' }}
      />
      <path
        d="m43.1 9.1 21.2-.3-3.8-2.9 1.6-1.6-4-.3s-11.3-.8-14.4-.8c-9.4-.5-11.6.6-11.6.6s-9.5 5.6-10.3 5.9l21.3-.6z"
        style={{ fill: 'url(#linear-grad-suv)' }}
      />
      <path
        d="M36.1 9.2c1.4 0 1.6-.1 3-.1 0 0 .6-.7.5-1.2-.1-.5-1.2-1-1.8-.7-.1 0-.1.1-.2.1s-.2.1-.4.3c-.2.1-.8.9-1.1 1.6zm0 0c1.4 0 1.6-.1 3-.1 0 0 .6-.7.5-1.2-.1-.5-1.2-1-1.8-.7-.1 0-.1.1-.2.1s-.2.1-.4.3c-.2.1-.8.9-1.1 1.6zm0 0c1.4 0 1.6-.1 3-.1 0 0 .6-.7.5-1.2-.1-.5-1.2-1-1.8-.7-.1 0-.1.1-.2.1s-.2.1-.4.3c-.2.1-.8.9-1.1 1.6zm14-.2c1.3-.1 1.1 0 2.5-.1 0 0 .5-.7.4-1.1s-1.4-.8-1.6-.7c-.1 0-.1.1-.2.1s-.2.1-.4.3c-.1.2-.4.8-.7 1.5zm0 0c1.3-.1 1.1 0 2.5-.1 0 0 .5-.7.4-1.1s-1.4-.8-1.6-.7c-.1 0-.1.1-.2.1s-.2.1-.4.3c-.1.2-.4.8-.7 1.5zm0 0c1.3-.1 1.1 0 2.5-.1 0 0 .5-.7.4-1.1s-1.4-.8-1.6-.7c-.1 0-.1.1-.2.1s-.2.1-.4.3c-.1.2-.4.8-.7 1.5z"
        style={{ fill: '#004680' }}
      />
      <path
        d="m58.5 22.3 6.9-1.9c.8-1.3 1.1-2.2 1.6-3.9l-.3-1.3c.1-2.3 0-3.5-.3-5.8l-1.6-.6-3.8-3 1.6-1.4s-4.8-.5-16.1-1.2-14.2.6-14.2.6l-4.4 2.5-5.4 3.3c-6.4.3-8.4.4-15.7 1.7C4.3 15.2 4 17.4 4.9 21l-.9.6 5.4 1"
        style={{
          fill: 'none',
          stroke: '#007ee5',
          strokeWidth: '.25',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <ellipse
        cx={35.2}
        cy={26}
        rx={31.2}
        ry={1}
        style={{
          fill: 'url(#linear-grad-suv-2)',
        }}
      />
      <path
        d="M4.8 19.8c38.4-.3 53.3-1.7 61.3-4.7m-58.4-3c15.3-1.2 27.9-1.7 57.2-2.2"
        style={{ fill: 'none', stroke: '#2070e8', strokeWidth: '.2' }}
      />
      <path
        d="M18.4 25.6c1.6-1.3 1.9-1.6 2.5-3.2h-1.6l-2.8 3.2h1.9zm30.9 0c-1.6-1.3-1.9-1.6-2.5-3.2h1.6l2.8 3.2h-1.9z"
        className="icon-suv-st7"
      />
      <path
        d="m65.4 20.5-7.6 2.3m-9.7.1h-29M4 21.8l6 1.3"
        style={{
          fill: 'none',
          stroke: '#091a33',
          strokeWidth: '.5',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d="m20.2 14.8-1.2.7c-.3.2-.3.5-.1.8.5.6.9 1.1 1.2 1.9.1.3.4.4.7.3l.7-.4c.5-.3 1-.4 1.6-.4 8.7-.5 14.1-.7 23-.7.9 0 1.8-.5 2.2-1.3l.7-1.3c.2-.3-.1-.7-.4-.7-10.4 0-16.7.2-27.2.8-.4-.1-.9 0-1.2.3z"
        style={{ fill: '#cce0ff' }}
      />
      <path
        d="m37.4 9.1-.6 1.3c-1 1.9-1 3.6-.6 8.6M24 9.4c-1 .8-1.9 1.7-2.2 3.5-.3 2.2-.3 2.9.3 6.7M53 9.1c-.6 2.9-2 7.3-2 7.3"
        style={{ fill: 'none', stroke: '#007ee5', strokeWidth: '.125' }}
      />
      <path
        d="M14.3 25.6c-2.8 0-5-2.3-5-5.1s2.2-5.1 5-5.1 5 2.3 5 5.1-2.2 5.1-5 5.1zm38.8 0c-2.8 0-5-2.3-5-5.1s2.2-5.1 5-5.1 5 2.3 5 5.1-2.3 5.1-5 5.1z"
        style={{ fill: '#fff', stroke: '#091a33', strokeWidth: '.75' }}
      />
      <path
        d="M14.3 24.9c-2.4 0-4.4-2-4.4-4.5s2-4.5 4.4-4.5 4.4 2 4.4 4.5-2 4.5-4.4 4.5zm39.2.3c-2.4 0-4.4-2-4.4-4.5s2-4.5 4.4-4.5c2.4 0 4.4 2 4.4 4.5s-2 4.5-4.4 4.5z"
        className="icon-suv-st7"
      />
      <path
        d="M14.4 22.2v2.9m1.1-3.5 2.2 1.8m-1.9-3.1 2.7-.7m-3.5-.3 1.2-2.6m-2.4 2.6-1.2-2.6m.4 3.6-2.7-.7m3 2-2.2 1.8m42.4-1.3v2.8m1.1-3.4 2.1 1.8m-1.9-3 2.6-.6m-3.3-.4 1.2-2.6m-2.5 2.6-1.2-2.6m.5 3.6-2.6-.6m2.9 1.8-2.1 1.8"
        style={{ fill: 'none', stroke: '#cce0ff', strokeWidth: '.5' }}
      />
    </symbol>
  </Fragment>
);
export const iconSuv = (
  <svg aria-hidden key="iconSuv" xmlns="http://www.w3.org/2000/svg" width={71} height={27} className="mt-0_5 mb-0_5">
    <use xlinkHref="#icon-suv" />
  </svg>
);
